import axios from "axios"
import _ from 'underscore'
const siteRoot = "https://geoffbanks.bet"
export const base_url = "https://api.geoff-banks.com/Geoff/";
const base_url_v0 = "https://v0.geoff-banks.com/";

const betslip_prod_api = process.env.VUE_APP_GLOBAL_API; 
const geoff_api = `${betslip_prod_api}/api/Geoff/`;

const media_api = process.env.VUE_APP_MEDIA_API; 
const payment_api = `${process.env.VUE_APP_PAYMENTS_API}/api`;

// DIRECTUS PROD
// const items_url = "https://be.geoff-banks.com/_/items/";
// DIRECTUS 
const items_url = `${betslip_prod_api}/api/cms/get-collection-data/`;
const directus_csm = `${betslip_prod_api}/api/cms/`;

const stream_api= 'https://geoffbanksuidev.z33.web.core.windows.net'
// const stream_api= 'https://geoffbanks.bet'
export const stream_url_rmg= `${stream_api}/videostream/rmg.html`
export const stream_url_atr= `${stream_api}/videostream/atr.html`

export const siteId=0 // geoffbanks

const paydoo_base_url = 'https://service.geoffbanks.bet/payment/paydoo/'
const paydoo_token = 'OGE4Mjk0MTg1ZTVjNjFmNTAxNWU2MWQyNWY3ZDBkY2V8ZGZxbnRYTkgzOQ=='
import {partnerCode} from "@/services/videoStream/constants";
import store from "../store"
import betslipStore from "@/store/betslipStore";
import {AUTH_TOKEN_KEY} from "@/services/betslip/_constants";

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 1024

export const Reg_API_KEY = "ishFiWjhUEWbXCXcgO3F9g26831";

// const utility = require("./utils");


export const SPORTSVG = {
    
    baseball: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
            <g>
                <path d="M14.0006 4.97069e-08C11.2315 -0.000233236 8.52446 0.820689 6.22192 2.35895C3.91938 3.89722 2.12471 6.08373 1.06486 8.64198C0.00500322 11.2002 -0.272423 14.0153 0.267659 16.7313C0.807742 19.4472 2.14108 21.942 4.09905 23.9001C6.05702 25.8582 8.55168 27.1918 11.2676 27.7321C13.9834 28.2724 16.7986 27.9952 19.3569 26.9356C21.9152 25.8759 24.1019 24.0814 25.6404 21.779C27.1788 19.4766 28 16.7697 28 14.0006C27.9956 10.289 26.5193 6.73056 23.8949 4.10592C21.2705 1.48128 17.7122 0.00468232 14.0006 4.97069e-08V4.97069e-08ZM14.0006 1.41539C14.3851 1.41539 14.7649 1.43426 15.1411 1.46729C15.1305 1.60647 15.1175 1.74447 15.1034 1.88247L14.3426 1.77986L14.2164 2.71284L14.9748 2.81663C14.9174 3.15239 14.8486 3.48501 14.7684 3.81448L14.0359 3.61279L13.7859 4.52336L14.5219 4.72505C14.4228 5.03998 14.3143 5.35137 14.1952 5.65685L13.4946 5.35962L13.1277 6.22891L13.826 6.52496C13.6907 6.81748 13.5465 7.10488 13.3931 7.38717L12.7385 7.00384L12.2667 7.81769L12.919 8.19984C12.7491 8.46877 12.5714 8.7318 12.3858 8.98893L11.7878 8.52656L11.2052 9.27318L11.7949 9.73555C11.5944 9.97852 11.3844 10.2156 11.1686 10.4432L10.6402 9.90775L9.97259 10.5753L10.5069 11.1085C10.2773 11.3247 10.0414 11.5335 9.7992 11.7348L9.33684 11.1368L8.59022 11.7147L9.05258 12.3116C8.79545 12.4971 8.53242 12.6748 8.2635 12.8447L7.88134 12.1936L7.06749 12.6654L7.44729 13.3283C7.165 13.4856 6.87759 13.6298 6.58508 13.7612L6.29021 13.0641L5.42564 13.4297L5.72051 14.128C5.41502 14.2459 5.10481 14.3556 4.78989 14.4535L4.5882 13.7211L3.67881 13.9711L3.8805 14.7036C3.55181 14.7822 3.2188 14.851 2.88147 14.91L2.77649 14.1539L1.84115 14.2813L1.94377 15.0386C1.78336 15.0551 1.62295 15.0692 1.46254 15.0798C1.43187 14.726 1.41536 14.3639 1.41536 14.0006C1.41879 10.6638 2.74583 7.46475 5.10527 5.10531C7.46471 2.74587 10.6638 1.41883 14.0006 1.41539V1.41539ZM1.57813 16.0187C1.74326 16.0057 1.90721 15.9904 2.06998 15.9739L2.17967 16.7818L3.11501 16.6545L3.00532 15.8453C3.38393 15.7816 3.75783 15.7038 4.12701 15.6094L4.34404 16.3985L5.25343 16.1591L5.0364 15.37C5.39182 15.2591 5.74135 15.1368 6.08497 15.0032L6.40462 15.7592L7.2739 15.3924L6.95898 14.6257C7.28924 14.4732 7.6132 14.3104 7.93088 14.1374L8.34606 14.8451L9.16109 14.3733L8.74355 13.6656C9.04786 13.4753 9.34431 13.2752 9.63289 13.0653L10.1377 13.7175L10.8843 13.1407L10.3795 12.4849C10.6539 12.2585 10.9205 12.0226 11.1792 11.7773L11.769 12.3611L12.4365 11.6935L11.8468 11.1038C12.0906 10.8458 12.3265 10.5793 12.5545 10.3041L13.2068 10.8077L13.7835 10.0611L13.1313 9.55744C13.342 9.26886 13.5425 8.97281 13.7328 8.66928L14.4405 9.08446L14.9182 8.27061L14.2105 7.85543C14.3851 7.5409 14.5478 7.21733 14.6988 6.88471L15.4513 7.21261L15.8182 6.34332L15.0645 6.02486C15.1989 5.68044 15.3212 5.33092 15.4313 4.97629L16.2145 5.18977L16.4657 4.28038L15.679 4.06336C15.7694 3.69457 15.848 3.32067 15.9149 2.94166L16.7205 3.05135L16.8431 2.12309L16.0411 2.00514C16.0564 1.86478 16.0694 1.72442 16.08 1.58288C18.6513 2.01856 21.0245 3.24011 22.8732 5.07956C24.722 6.91901 25.9555 9.28602 26.4041 11.8551C26.239 11.8669 26.075 11.8822 25.9123 11.8999L25.8026 11.092L24.8672 11.2182L24.9769 12.0285C24.5987 12.0922 24.2248 12.1708 23.8552 12.2644L23.6382 11.4753L22.7288 11.7254L22.9458 12.5156C22.592 12.6253 22.2381 12.7515 21.8973 12.8813L21.5776 12.1252L20.7083 12.4932L21.0292 13.2504C20.6989 13.403 20.3749 13.5658 20.0573 13.7387L19.6421 13.0311L18.827 13.5029L19.2446 14.2105C18.9403 14.4016 18.6438 14.6021 18.3552 14.8121L17.8504 14.1598L17.1026 14.7437L17.6074 15.3959C17.3322 15.6224 17.0657 15.8583 16.8078 16.1036L16.218 15.5139L15.5504 16.1815L16.1402 16.7642C15.8956 17.0236 15.6597 17.2902 15.4325 17.5638L14.7802 17.0602L14.2046 17.8104L14.8569 18.314C14.6461 18.6026 14.4452 18.899 14.2541 19.2033L13.5465 18.787L13.0747 19.6008L13.7823 20.016C13.6078 20.3305 13.4446 20.6545 13.2929 20.9879L12.538 20.6683L12.1712 21.5376L12.9249 21.856C12.7904 22.2004 12.6681 22.55 12.558 22.9046L11.7713 22.6888L11.5213 23.5981L12.3068 23.814C12.2172 24.1832 12.1393 24.5571 12.0709 24.9357L11.2653 24.8272L11.1379 25.7613L11.9423 25.871C11.9235 26.0491 11.907 26.2249 11.894 26.4101C9.30753 25.9655 6.92398 24.7258 5.07504 22.8633C3.22611 21.0009 2.00377 18.6083 1.57813 16.0187V16.0187ZM14.0006 26.5846C13.6054 26.5846 13.2162 26.5657 12.8305 26.5304C12.8435 26.3511 12.8576 26.1765 12.8765 25.9961L13.6373 26.0987L13.7635 25.1633L13.0051 25.0607C13.0633 24.7234 13.1317 24.3904 13.2103 24.0617L13.9463 24.2646L14.1964 23.3552L13.4603 23.1523C13.5594 22.8378 13.6683 22.5276 13.7871 22.2217L14.4877 22.5177L14.8545 21.6484L14.1539 21.3488C14.2899 21.0563 14.4342 20.7689 14.5868 20.4866L15.2414 20.87L15.7132 20.0549L15.0609 19.6728C15.2308 19.4039 15.4085 19.1412 15.5941 18.8849L16.1921 19.3461L16.7688 18.6006L16.172 18.1383C16.3725 17.8941 16.5825 17.6582 16.7983 17.4306L17.3314 17.9637L17.999 17.2973L17.4647 16.7642C17.7006 16.5483 17.9365 16.3384 18.1724 16.1378L18.6348 16.7347L19.3814 16.1579L18.9297 15.5693C19.1868 15.383 19.4498 15.2053 19.7187 15.0362L20.1009 15.6873L20.9147 15.2155L20.5326 14.562C20.8141 14.4048 21.1015 14.2605 21.3948 14.1292L21.6897 14.8262L22.5578 14.4594L22.2629 13.7612C22.568 13.6416 22.8782 13.5331 23.1935 13.4356L23.3952 14.1681L24.3046 13.918L24.1029 13.1844C24.4316 13.1058 24.7646 13.0373 25.102 12.9792L25.2034 13.734L26.1387 13.6078L26.0361 12.8506C26.1989 12.8341 26.3628 12.8199 26.5268 12.8081C26.5645 13.2044 26.5846 13.6055 26.5846 14.0112C26.578 17.3457 25.2498 20.5416 22.8909 22.8985C20.5321 25.2553 17.3351 26.5809 14.0006 26.5846V26.5846Z" fill="currentColor"/>
            </g>
        </svg>`,
    award:`<svg width="100%" height="100%" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
            <path d="M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193.684 1.365 1.086 1.072L12.387 6l.248 1.506-1.086 1.072-.684 1.365-1.51.229L8 10.874l-1.355-.702-1.51-.229-.684-1.365-1.086-1.072L3.614 6l-.25-1.506 1.087-1.072.684-1.365 1.51-.229L8 1.126l1.356.702 1.509.229z"/>
            <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
        </svg>`,
    сycling: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M0.256085 14.6518C0.617153 13.8038 0.931207 12.8992 2.06142 12.9234C3.78401 12.9578 5.50661 12.9234 7.2292 12.9234C5.75296 11.9459 4.13944 11.7739 2.5278 11.8873C1.57812 11.954 1.28663 11.3226 1.12491 10.6446C1.04592 10.3127 1.34869 9.72584 1.64206 9.46882C2.57294 8.65929 3.57903 7.94287 4.59077 7.16573C4.31809 6.70026 4.03789 6.21859 3.59032 5.44955C5.73039 4.89907 7.67865 4.28991 9.66264 3.90944C12.7787 3.32051 15.9061 3.3367 18.8962 4.66634C23.5261 6.73061 25.7997 10.8774 27.1725 15.7628C27.4339 16.6938 26.9901 17.1916 25.9972 17.2058C24.0564 17.2362 22.1138 17.2544 20.1674 17.1937C19.3622 17.1693 18.5641 17.0242 17.7961 16.7626C15.6334 16.0097 13.4971 15.1699 11.1558 14.2915L12.1092 15.8053C9.15865 16.8476 6.27952 17.8716 3.40414 18.8592C3.27149 18.8894 3.13407 18.8851 3.00327 18.8468C2.87246 18.8084 2.75202 18.7371 2.65192 18.6387C1.86773 17.5458 1.13431 16.4125 0.395248 15.2791C0.297459 15.1071 0.190266 14.8056 0.256085 14.6518ZM15.3777 6.28133C12.098 5.18645 8.7957 5.23502 5.42574 6.07895L5.93349 7.1374C7.55453 6.84799 9.11352 6.45942 10.6913 6.31573C12.2691 6.17204 13.8149 6.28133 15.3777 6.28133Z" fill="currentColor"/>
        <path d="M11.7651 19.4765C12.0453 19.4765 12.3594 19.3955 12.5982 19.5028C12.837 19.6101 13.1943 19.8833 13.2395 20.1342C13.4595 21.3607 13.2395 21.5934 12.0058 21.7411C11.5677 21.5752 10.9208 21.5388 10.7308 21.219C10.208 20.3083 10.7534 19.4846 11.7651 19.4765Z" fill="currentColor"/>
        <path d="M13.9108 17.6288C14.9357 16.5238 14.9263 16.5136 16.3179 17.2928L13.8844 19.6748C13.6475 19.436 13.3014 19.092 12.8106 18.6022C13.1886 18.2703 13.5817 17.9829 13.9108 17.6288Z" fill="currentColor"/>
        <path d="M10.3829 19.007C10.2156 19.4887 10.052 19.9643 9.86202 20.5087L7.14461 18.6873C8.66974 17.6916 8.81643 17.7057 10.3829 19.007Z" fill="currentColor"/>
        <path d="M12.7242 24.6514H11.1446V22.2087H12.7242V24.6514Z" fill="currentColor"/>
        </g>
        </svg>`,
    ufc: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M24.5544 14.9492L25.9107 13.5928C26.2756 13.2263 26.4802 12.7301 26.4799 12.213C26.4796 11.6958 26.2744 11.1999 25.9091 10.8338L25.5206 10.4452C25.2374 10.1611 24.8731 9.97185 24.4778 9.90344C24.8027 9.5305 24.9742 9.0483 24.9578 8.55396C24.9413 8.05961 24.7382 7.58987 24.3893 7.23933L23.9058 6.75582C23.7204 6.57025 23.4995 6.42399 23.2563 6.32583C23.0131 6.22767 22.7526 6.17961 22.4904 6.18454C22.5972 5.84377 22.6085 5.48023 22.5231 5.13348C22.4377 4.78672 22.2589 4.47001 22.0061 4.21778L21.5226 3.73427C21.2461 3.45864 20.8933 3.27207 20.5099 3.19856C20.1264 3.12505 19.7297 3.16796 19.3708 3.32177C19.326 2.87366 19.1272 2.45496 18.8084 2.13692L18.3257 1.65421C17.9593 1.28868 17.4629 1.08339 16.9454 1.08339C16.4279 1.08339 15.9315 1.28868 15.5651 1.65421L13.0583 4.16113C12.5257 3.83762 11.9708 3.55207 11.398 3.30661C9.15289 2.30767 7.69603 3.74704 7.23966 4.64704L7.23089 4.66539C7.16467 4.80502 5.61207 8.12418 5.48042 10.6702C5.39827 11.9537 5.55048 13.2415 5.92961 14.4705L2.02019 18.3801C1.89323 18.507 1.8219 18.6792 1.8219 18.8588C1.8219 19.0383 1.89323 19.2105 2.02019 19.3375L9.73132 27.049C9.85828 27.1759 10.0305 27.2473 10.21 27.2473C10.3896 27.2473 10.5618 27.1759 10.6887 27.049L14.5016 23.2359C17.5222 22.004 19.8551 19.813 19.9565 19.7165L24.3717 15.3011C24.4664 15.2046 24.53 15.0821 24.5544 14.9492ZM23.3991 11.0811C23.5964 10.8847 23.8634 10.7745 24.1417 10.7747C24.42 10.7748 24.6869 10.8853 24.8839 11.0819L25.2725 11.4705C25.469 11.6674 25.5793 11.9343 25.5793 12.2125C25.5793 12.4907 25.469 12.7576 25.2725 12.9545L24.2385 13.9886C23.8161 13.1407 23.3688 12.3391 22.8965 11.5838L23.3991 11.0811ZM21.7827 7.39013C21.9799 7.19375 22.247 7.08356 22.5253 7.08371C22.8036 7.08386 23.0705 7.19433 23.2675 7.39093L23.7526 7.87604C23.9492 8.07305 24.0596 8.33997 24.0598 8.6183C24.0599 8.89662 23.9498 9.16365 23.7534 9.36088L22.358 10.7564C21.8318 9.98163 21.2567 9.24129 20.6362 8.53987L21.7827 7.39013ZM19.4012 4.37017C19.5985 4.17449 19.8653 4.06489 20.1432 4.06534C20.4212 4.06579 20.6876 4.17625 20.8843 4.37257L21.3678 4.85608C21.5644 5.0531 21.6749 5.32001 21.675 5.59834C21.6752 5.87666 21.565 6.1437 21.3686 6.34093L19.9261 7.78348C19.7501 7.60742 19.5719 7.43508 19.3916 7.26646C18.8902 6.80035 18.3593 6.367 17.8023 5.96912L19.4012 4.37017ZM16.2034 2.28932C16.4008 2.09322 16.6679 1.98342 16.9461 1.98402C17.2243 1.98462 17.4909 2.09556 17.6874 2.29251L18.1717 2.77682C18.3682 2.97376 18.4786 3.24062 18.4786 3.51884C18.4786 3.79706 18.3682 4.06392 18.1717 4.26087L16.9989 5.43374C16.5034 5.13135 16.1053 4.92789 15.8555 4.80262L15.6633 4.70448C15.2117 4.43791 14.6929 4.3069 14.1689 4.32709L16.2034 2.28932ZM9.3316 24.7136C9.37897 24.6815 9.4233 24.6452 9.46404 24.6051L11.2775 22.7915C11.3568 22.7122 11.4197 22.6181 11.4626 22.5145C11.5054 22.4109 11.5275 22.2999 11.5274 22.1878C11.5273 22.0756 11.5051 21.9646 11.4621 21.8611C11.4191 21.7575 11.3561 21.6635 11.2767 21.5843L7.48859 17.796C7.40945 17.7167 7.31544 17.6537 7.21194 17.6108C7.10844 17.5678 6.99748 17.5457 6.88542 17.5457C6.77336 17.5457 6.6624 17.5678 6.5589 17.6108C6.4554 17.6537 6.36139 17.7167 6.28225 17.796L4.4177 19.6606C4.3931 19.6828 4.36966 19.7063 4.34749 19.7309L3.46268 18.846L6.87824 15.4303L13.632 22.1843L10.2156 25.6008L9.3316 24.7136ZM19.0182 18.7335C18.8985 18.8452 16.9645 20.6277 14.488 21.7607L7.39524 14.6675C7.40077 14.5589 7.38082 14.4504 7.337 14.3508C7.32743 14.3412 6.72107 12.9481 6.83436 10.7316C6.94765 8.51513 8.34707 5.47842 8.45079 5.25342C8.59041 4.99411 9.30846 3.85794 10.8435 4.54411C11.3269 4.75134 11.7974 4.9874 12.2525 5.25103C12.2337 5.30894 12.218 5.3678 12.2054 5.42736C11.4344 6.00306 10.7301 6.66299 10.1055 7.39492C9.99495 7.52478 9.93747 7.69159 9.94457 7.862C9.95167 8.03241 10.0228 8.19386 10.1438 8.31407L10.1829 8.35317C10.3196 8.46953 10.4969 8.52683 10.6759 8.51247C10.8548 8.4981 11.0207 8.41325 11.1371 8.27657C11.3414 8.03721 11.5472 7.8154 11.7499 7.61274C11.9972 7.3654 12.2397 7.14518 12.4727 6.94891C12.732 6.72949 12.9706 6.54837 13.1908 6.39039C13.526 6.14394 13.8797 5.92361 14.2487 5.73135C14.2839 5.71465 14.3175 5.69489 14.3492 5.67231C14.5829 5.69419 14.8087 5.76836 15.0098 5.88933C15.0681 5.92204 15.1463 5.96194 15.242 6.00981C15.4989 6.13906 15.7524 6.27763 16.0024 6.4255C16.0165 6.4328 16.0301 6.44106 16.043 6.45023C16.2936 6.59704 16.5377 6.75343 16.7826 6.92178C16.7961 6.92982 16.8089 6.93889 16.8209 6.94891C17.5892 7.47985 18.3066 8.08082 18.9639 8.74412L19.0573 8.83748C19.2376 9.0178 19.4115 9.20609 19.5855 9.39918L19.6732 9.49812C20.2931 10.2021 20.8635 10.948 21.3806 11.7306L21.4173 11.7864C21.5729 12.0218 21.7309 12.2596 21.8777 12.5101L21.9128 12.5675C22.3138 13.2303 22.6994 13.9351 23.0696 14.6819L19.0158 18.7359L19.0182 18.7335Z" fill="currentColor"/>
        </g>
        </svg>`,
    tennis: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M27.7688 11.4647C27.3068 8.95461 26.1674 6.61857 24.4738 4.70917C22.7802 2.79978 20.5968 1.38968 18.1597 0.63136C15.7226 -0.126962 13.1246 -0.204651 10.6466 0.406692C8.16852 1.01803 5.90476 2.29515 4.10006 4.09993C1.47445 6.72544 -0.000610379 10.2864 -0.000610352 13.9994C-0.000610324 17.7124 1.47445 21.2734 4.10006 23.8989C6.72568 26.5244 10.2868 27.9994 14 27.9994C17.7132 27.9994 21.2743 26.5244 23.8999 23.8989C25.504 22.2949 26.6942 20.325 27.3682 18.159C28.0421 15.993 28.1796 13.6956 27.7688 11.4647ZM22.9008 5.09542C24.7076 6.89567 25.9205 9.20541 26.3769 11.7147C26.4812 12.2868 26.5462 12.8653 26.5715 13.4462C24.9386 13.6824 23.2731 13.5344 21.7075 13.0139C20.1418 12.4934 18.7192 11.6148 17.5528 10.4479C16.3864 9.28107 15.5083 7.85818 14.9884 6.2924C14.4685 4.72662 14.3211 3.06113 14.5579 1.42838C17.7003 1.56533 20.6772 2.87548 22.9008 5.10014V5.09542ZM1.43312 14.5231C3.07085 14.2808 4.74258 14.4252 6.31448 14.9449C7.88637 15.4645 9.31476 16.345 10.4853 17.5157C11.6559 18.6864 12.5361 20.1149 13.0554 21.6869C13.5748 23.2588 13.7189 24.9305 13.4762 26.5681C10.3244 26.4364 7.33696 25.1258 5.10566 22.8959C2.87436 20.666 1.56196 17.6795 1.4284 14.5278L1.43312 14.5231ZM22.9008 22.8975C20.645 25.1547 17.6152 26.4694 14.4258 26.5752C14.6654 24.8115 14.4941 23.0163 13.9254 21.3297C13.3567 19.6432 12.4059 18.1108 11.1473 16.8523C9.88859 15.5938 8.35609 14.6432 6.66939 14.0746C4.98269 13.5061 3.18741 13.335 1.42368 13.5748C1.53121 10.3815 2.85004 7.34873 5.11241 5.09237C7.37477 2.83602 10.4111 1.52518 13.6048 1.42602C13.3882 3.05636 13.5222 4.71416 13.9979 6.28855C14.4735 7.86293 15.2799 9.3176 16.3631 10.5553C17.4463 11.7929 18.7812 12.785 20.2787 13.4652C21.7762 14.1454 23.4016 14.4981 25.0464 14.4995C25.5568 14.4991 26.0667 14.4653 26.5727 14.3981C26.4726 17.5972 25.157 20.6378 22.8937 22.9011L22.9008 22.8975Z" fill="currentColor"/>
        </g>
        </svg>`,
    special: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M14.0006 4.97069e-08C11.2315 -0.000233236 8.52446 0.820689 6.22192 2.35895C3.91938 3.89722 2.12471 6.08373 1.06486 8.64198C0.00500322 11.2002 -0.272423 14.0153 0.267659 16.7313C0.807742 19.4472 2.14108 21.942 4.09905 23.9001C6.05702 25.8582 8.55168 27.1918 11.2676 27.7321C13.9834 28.2724 16.7986 27.9952 19.3569 26.9356C21.9152 25.8759 24.1019 24.0814 25.6404 21.779C27.1788 19.4766 28 16.7697 28 14.0006C27.9956 10.289 26.5193 6.73056 23.8949 4.10592C21.2705 1.48128 17.7122 0.00468232 14.0006 4.97069e-08V4.97069e-08ZM14.0006 26.5846C11.5113 26.5849 9.07796 25.8469 7.00815 24.4641C4.93834 23.0813 3.32509 21.1158 2.3724 18.8161C1.4197 16.5164 1.17038 13.9859 1.65594 11.5445C2.14151 9.10305 3.34015 6.86048 5.1003 5.10033C6.86044 3.34019 9.10302 2.14154 11.5444 1.65598C13.9858 1.17041 16.5164 1.41974 18.8161 2.37243C21.1158 3.32512 23.0813 4.93838 24.4641 7.00819C25.8469 9.078 26.5848 11.5114 26.5846 14.0006C26.5808 17.3369 25.2538 20.5356 22.8947 22.8947C20.5355 25.2539 17.3369 26.5809 14.0006 26.5846V26.5846Z" fill="currentColor"/>
        <path d="M16.0505 11.5319L14.0005 5.22278L11.9494 11.5319H5.31592L10.6826 15.4313L8.63265 21.7416L14.0005 17.8422L19.3672 21.7416L17.3173 15.4313L22.684 11.5319H16.0505Z" fill="currentColor"/>
        </g>
        </svg>`,
    snooker: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M14.0006 4.97069e-08C11.2315 -0.000233236 8.52446 0.820689 6.22192 2.35895C3.91938 3.89722 2.12471 6.08373 1.06486 8.64198C0.00500322 11.2002 -0.272423 14.0153 0.267659 16.7313C0.807742 19.4472 2.14108 21.942 4.09905 23.9001C6.05702 25.8582 8.55168 27.1918 11.2676 27.7321C13.9834 28.2724 16.7986 27.9952 19.3569 26.9356C21.9152 25.8759 24.1019 24.0814 25.6404 21.779C27.1788 19.4766 28 16.7697 28 14.0006C27.9956 10.289 26.5193 6.73056 23.8949 4.10592C21.2705 1.48128 17.7122 0.00468232 14.0006 4.97069e-08V4.97069e-08ZM14.0006 26.5846C11.5113 26.5849 9.07796 25.8469 7.00815 24.4641C4.93834 23.0813 3.32509 21.1158 2.3724 18.8161C1.4197 16.5164 1.17038 13.9859 1.65594 11.5445C2.14151 9.10305 3.34015 6.86048 5.1003 5.10033C6.86044 3.34019 9.10302 2.14154 11.5444 1.65598C13.9858 1.17041 16.5164 1.41974 18.8161 2.37243C21.1158 3.32512 23.0813 4.93838 24.4641 7.00819C25.8469 9.078 26.5848 11.5114 26.5846 14.0006C26.5808 17.3369 25.2538 20.5356 22.8947 22.8947C20.5355 25.2539 17.3369 26.5809 14.0006 26.5846V26.5846Z" fill="currentColor"/>
        <path d="M14.0784 10.9068C13.0405 10.9068 12.413 11.4388 12.413 12.2915C12.413 13.1691 13.0405 13.6892 14.0784 13.6892C15.1164 13.6892 15.7663 13.1691 15.7663 12.2915C15.7663 11.4411 15.1175 10.9068 14.0784 10.9068Z" fill="currentColor"/>
        <path d="M14.0784 9.74498C14.9772 9.74498 15.528 9.27318 15.528 8.53364C15.528 7.75517 14.9383 7.30933 14.0784 7.30933C13.2186 7.30933 12.6512 7.75517 12.6512 8.53364C12.6512 9.27554 13.1915 9.74498 14.0784 9.74498Z" fill="currentColor"/>
        <path d="M13.9747 3.85693C10.2274 3.85693 7.19495 7.02859 7.19495 10.941C7.19495 14.8534 10.2321 18.0262 13.9794 18.0262C17.7266 18.0262 20.7591 14.8534 20.7591 10.941C20.7591 7.02859 17.7219 3.85693 13.9747 3.85693ZM14.0785 14.9501C12.1913 14.9501 10.9965 13.9487 10.9965 12.341C10.9965 11.3892 11.4293 10.6897 12.2078 10.2769C11.6015 9.89358 11.2642 9.27553 11.2642 8.45932C11.2642 6.97552 12.4001 6.04843 14.0761 6.04843C15.7522 6.04843 16.9069 6.97552 16.9069 8.45932C16.9069 9.27553 16.5613 9.89358 15.9444 10.2769C16.7335 10.685 17.177 11.3892 17.177 12.341C17.1829 13.9487 15.9609 14.9501 14.0785 14.9501Z" fill="currentColor"/>
        </g>
        </svg>`,
    rugby: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M25.8169 2.17615C23.7823 0.143358 20.6274 -0.492612 16.9316 0.38387C13.3516 1.23376 9.6625 3.41571 6.54477 6.52733C2.44852 10.6195 0 15.6564 0 20.0041C0 22.3873 0.75469 24.3981 2.18196 25.8273C3.60924 27.2565 5.62362 28 7.97204 28C9.01383 27.9925 10.0514 27.8637 11.065 27.6161C14.645 26.7662 18.3341 24.5842 21.4519 21.4726C25.5515 17.3804 27.9989 12.3436 28 7.99931C28.0056 5.61616 27.2453 3.60303 25.8169 2.17615ZM17.2386 1.73444C18.1502 1.51165 19.0832 1.39529 20.0201 1.38754C22.0187 1.38754 23.6923 1.99345 24.8721 3.17173C26.0374 4.3315 26.656 6.00006 26.656 7.99816C26.656 9.48401 26.3185 11.0947 25.6898 12.7275C23.6192 8.25948 20.7287 5.61732 18.5816 4.16268C17.5302 3.44162 16.4065 2.8388 15.2299 2.36463C15.8857 2.11071 16.5567 1.90022 17.2386 1.73444V1.73444ZM20.5116 20.4759C18.2543 22.7284 15.6921 24.4617 13.112 25.5058C10.5668 20.9176 7.82583 18.4142 5.82832 17.0821C5.97903 16.8196 6.17923 16.4855 6.4233 16.0946L6.95079 16.4704L7.46254 15.7084L6.91818 15.3222C7.09813 15.0501 7.29383 14.7618 7.50528 14.4573L8.0474 14.8863L8.59626 14.1532L8.0339 13.7115C8.24085 13.4278 8.45905 13.1376 8.68849 12.8408L9.24411 13.3264L9.82671 12.6211L9.25648 12.1227C9.48142 11.8406 9.71949 11.5553 9.97068 11.267L10.533 11.8105L11.1483 11.1364L10.5747 10.5813C10.8206 10.31 11.0748 10.0379 11.3372 9.76499L11.8996 10.3593L12.5485 9.71874L11.9862 9.11631C12.2464 8.86115 12.5129 8.6083 12.7859 8.35777L13.3212 8.99489L13.9961 8.38899L13.4607 7.75302C13.7464 7.50788 14.0384 7.2666 14.3369 7.02917L14.8992 7.71139L15.5864 7.11474L15.0612 6.4753C15.3536 6.26023 15.6535 6.05055 15.961 5.84627L16.484 6.49958L17.179 5.91102L16.7291 5.35252C17.0763 5.13822 17.431 4.93394 17.7931 4.73968C20.2203 6.32498 23.2031 9.11168 25.2051 13.8664C24.1366 16.1686 22.5271 18.4651 20.5116 20.477V20.4759ZM7.48841 7.52291C9.47692 5.53753 11.7028 3.95686 13.9691 2.89768C14.9863 3.22094 15.9667 3.65591 16.8934 4.19506C16.6425 4.33844 16.3962 4.48529 16.1522 4.63677L15.6888 4.05862L14.9948 4.64718L15.3851 5.13398C15.0792 5.34096 14.7789 5.55488 14.4853 5.77226L14.059 5.25308L13.3718 5.85089L13.761 6.32382C13.4611 6.56433 13.1664 6.80793 12.877 7.05461L12.4743 6.57705L11.7995 7.1818L12.201 7.65936C11.9138 7.92068 11.6353 8.18394 11.3653 8.44912L10.9379 7.98659L10.28 8.63297L10.7141 9.09549C10.4374 9.38072 10.172 9.66363 9.91781 9.94422L9.44768 9.49558L8.83583 10.1755L9.31271 10.638C9.05103 10.941 8.80284 11.2374 8.56815 11.5272L8.05415 11.0762L7.47042 11.7804L8.00016 12.243C7.76059 12.5529 7.53228 12.857 7.31745 13.1507L6.74834 12.6916L6.19948 13.4247L6.78658 13.8872C6.56164 14.2041 6.36144 14.507 6.17361 14.7915L5.54489 14.344L5.03314 15.1048L5.67873 15.5673C5.42342 15.9755 5.21647 16.3259 5.05788 16.6022C4.18296 16.078 3.24683 15.67 2.27194 15.3881C3.28982 12.6789 5.104 9.9026 7.48841 7.52291ZM10.7614 26.2644C7.53003 27.031 4.81719 26.5211 3.12336 24.8282C1.96264 23.6684 1.34967 21.9999 1.34967 20.0041C1.36757 18.7325 1.577 17.4714 1.97052 16.2658C3.5845 16.6994 8.16325 18.5298 12.255 25.8307C11.7556 26.0019 11.2577 26.1464 10.7614 26.2644V26.2644Z" fill="currentColor"/>
        </g>
        </svg>`,
    p: `<svg width="100%" height="100%" viewBox="0 0 16 16" fill="none">
    <path d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z" fill="#00984A"/>
    <path d="M8.24609 9.13867H6.04883V7.87305H8.24609C8.60547 7.87305 8.89648 7.81445 9.11914 7.69727C9.3457 7.57617 9.51172 7.41211 9.61719 7.20508C9.72266 6.99414 9.77539 6.75391 9.77539 6.48438C9.77539 6.22266 9.72266 5.97852 9.61719 5.75195C9.51172 5.52539 9.3457 5.3418 9.11914 5.20117C8.89648 5.06055 8.60547 4.99023 8.24609 4.99023H6.57617V12.25H4.96484V3.71875H8.24609C8.91016 3.71875 9.47656 3.83789 9.94531 4.07617C10.418 4.31055 10.7773 4.63672 11.0234 5.05469C11.2734 5.46875 11.3984 5.94141 11.3984 6.47266C11.3984 7.02344 11.2734 7.49805 11.0234 7.89648C10.7773 8.29492 10.418 8.60156 9.94531 8.81641C9.47656 9.03125 8.91016 9.13867 8.24609 9.13867Z" fill="white"/>
    </svg>`, //???
    nfl: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M25.8169 2.17615C23.7823 0.143358 20.6274 -0.492612 16.9316 0.38387C13.3516 1.23376 9.6625 3.41571 6.54477 6.52733C2.44852 10.6195 0 15.6564 0 20.0041C0 22.3873 0.75469 24.3981 2.18196 25.8261C3.60924 27.2542 5.62362 28 7.97204 28C9.01383 27.9925 10.0514 27.8637 11.065 27.6161C14.645 26.7662 18.3341 24.5842 21.4519 21.4726C25.5515 17.3804 27.9989 12.3436 28 7.99931C28.0056 5.61616 27.2453 3.60303 25.8169 2.17615ZM10.7614 26.2644C7.53003 27.031 4.81719 26.5211 3.12336 24.8282C1.96264 23.6684 1.34967 21.9999 1.34967 20.0041C1.34967 18.6848 1.61735 17.2683 2.11561 15.8264C3.06766 16.0951 3.98208 16.4888 4.83631 16.9977C4.99827 16.7028 5.2862 16.2045 5.6821 15.5627L5.03651 15.1002L5.54826 14.3393L6.17698 14.7868C6.36481 14.5024 6.56839 14.1994 6.78996 13.8826L6.20285 13.4201L6.74834 12.6916L7.31858 13.1437C7.53453 12.8489 7.76059 12.5459 8.00129 12.236L7.47154 11.7735L8.05527 11.0693L8.56927 11.5191C8.80321 11.2312 9.05065 10.934 9.31271 10.6311L8.83696 10.1685L9.44768 9.49558L9.91781 9.94422C10.172 9.66285 10.4371 9.37956 10.713 9.09434L10.28 8.63181L10.9289 7.99006L11.3563 8.45259C11.6263 8.18895 11.9041 7.92415 12.192 7.66167L11.7905 7.18527L12.4653 6.58052L12.8736 7.05345C13.1608 6.80755 13.4558 6.56433 13.7587 6.32382L13.3685 5.84974L14.059 5.25308L14.4842 5.77111C14.7777 5.55372 15.078 5.3398 15.384 5.13283L14.9926 4.64371L15.6865 4.05515L16.151 4.6333C16.5469 4.38701 16.9541 4.15112 17.3691 3.9268C16.4884 3.40033 15.5612 2.96052 14.6 2.61323C15.4546 2.24628 16.3371 1.95235 17.2386 1.73444C18.1502 1.51165 19.0832 1.39529 20.0201 1.38754C22.0187 1.38754 23.6923 1.99345 24.8721 3.17173C26.0374 4.3315 26.656 6.00006 26.656 7.99816C26.656 9.65977 26.2308 11.4752 25.4559 13.3045C23.473 8.80988 20.6443 6.09603 18.27 4.4957C17.7451 4.76165 17.2323 5.04842 16.7314 5.35599L17.1813 5.91333L16.4862 6.50189L15.9643 5.84974C15.6607 6.05325 15.3626 6.26485 15.0713 6.47992L15.5932 7.11589L14.906 7.71255L14.3436 7.03264C14.0437 7.2693 13.752 7.51058 13.4686 7.75649L14.0017 8.39014L13.3269 8.99605L12.7926 8.36124C12.5189 8.611 12.2527 8.86346 11.9941 9.11862L12.5564 9.7199L11.9075 10.3605L11.3518 9.76731C11.0894 10.0387 10.8352 10.3108 10.5893 10.5837L11.1618 11.1375L10.5465 11.8117L9.98417 11.2694C9.73673 11.5577 9.49867 11.8429 9.26997 12.125L9.83908 12.6222L9.25648 13.3276L8.70199 12.8419C8.47704 13.1391 8.2521 13.4305 8.0474 13.7126L8.60976 14.1543L8.06202 14.8874L7.5199 14.4596C7.30921 14.7626 7.11388 15.0509 6.93392 15.3245L7.47716 15.7096L6.96541 16.4716L6.43792 16.0958C6.04202 16.7283 5.76309 17.2116 5.61575 17.4833C7.70323 18.879 10.289 21.3419 12.7015 25.6735C12.0672 25.9111 11.4192 26.1084 10.7614 26.2644V26.2644Z" fill="currentColor"/>
        </g>
        </svg>`,
    motor: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M27.0982 6.26256C25.7405 6.2524 24.2451 6.23209 22.7266 6.13561C22.6884 6.13561 22.6491 6.13561 22.6109 6.12799C21.7794 6.07467 20.9432 6.00104 20.1186 5.88678C19.579 5.81043 19.0478 5.67476 18.533 5.48181L18.4173 5.43991C17.5656 5.09358 16.733 4.69301 15.9238 4.24023C15.4393 3.98633 14.95 3.721 14.4504 3.47852L14.3348 3.4252C13.3968 2.98468 12.4172 2.62287 11.374 2.50989C10.9617 2.46914 10.547 2.46617 10.1342 2.501L10.0186 2.51116C8.5151 2.64953 6.75717 3.20685 5.57635 4.22372C5.04666 4.67948 4.98421 4.91307 4.9287 5.51862C4.92176 5.59987 4.9125 5.69255 4.90094 5.80046L4.6812 7.75804L4.66154 7.94212L4.29954 11.2035L4.28219 11.3634L3.88782 14.9181L3.86931 15.0844L3.30261 20.198L4.02082 19.8933C4.5054 19.6889 4.99693 19.4629 5.47227 19.2458C6.44722 18.799 7.45687 18.3369 8.45727 18.0271C8.55674 17.9966 8.65504 17.97 8.7545 17.9471C8.79382 17.937 8.83199 17.9281 8.87016 17.9205C10.2175 17.6437 11.5672 18.0322 12.9007 18.6352L13.0163 18.686C13.6582 18.9818 14.2954 19.3207 14.9269 19.6648C15.6012 20.0266 16.2916 20.3985 16.9786 20.7058L17.0943 20.7565C17.336 20.8619 17.5777 20.9597 17.8171 21.046C18.8682 21.4262 19.948 21.7032 21.0438 21.8737C21.082 21.8801 21.119 21.8864 21.1595 21.8902C21.8961 22.0008 22.6388 22.0564 23.3823 22.0565C23.6136 22.0565 23.8449 22.0565 24.0762 22.04C24.3075 22.0235 24.5192 22.0311 24.725 22.0324C25.5751 22.0426 26.5362 22.0514 26.6414 20.4963L26.8785 16.9747L26.8878 16.8477L27.1191 13.4023L27.1272 13.2753L27.3712 9.66738L27.3793 9.54043L27.6002 6.27017L27.0982 6.26256ZM18.4358 6.51646C18.9476 6.6959 19.4734 6.82338 20.0064 6.89731C20.8368 7.00903 21.6764 7.08647 22.5103 7.14233L22.279 9.496C20.9101 9.4646 19.5464 9.30191 18.2034 9.00978L18.4358 6.51646ZM14.7904 8.05384C15.8562 8.50378 16.954 8.85621 18.0727 9.10753L17.7257 12.7726C16.6256 12.5518 15.5506 12.2002 14.5198 11.724C14.2457 11.597 13.9751 11.4587 13.7102 11.3228L14.0572 7.71995C14.2943 7.83548 14.5406 7.94847 14.7904 8.05384ZM10.0487 3.52803C10.4587 3.48625 10.8715 3.48625 11.2815 3.52803C12.3062 3.63721 13.2696 4.01806 14.2399 4.4954L13.952 7.54222C13.812 7.47621 13.6732 7.41527 13.5356 7.34164C12.5549 6.8643 11.5417 6.37173 10.4037 6.18639C10.2152 6.15592 10.0267 6.13307 9.83817 6.11656L10.0487 3.52803ZM5.67928 7.17406C6.91422 6.44517 8.31236 6.1163 9.71095 6.22574L9.41835 9.81972C8.00345 9.7212 6.58797 10.0022 5.29416 10.6386L5.67928 7.17406ZM8.84009 16.8972C8.62676 16.9332 8.41552 16.9828 8.20746 17.0458C7.15386 17.372 6.11877 17.8468 5.11837 18.3051L4.41057 18.6263L4.87318 14.4179C6.18019 13.6772 7.65056 13.3548 9.1165 13.4873L8.84009 16.8972ZM9.24834 13.3693L9.52822 9.95556C9.83998 9.98174 10.1501 10.0279 10.4569 10.0939C11.514 10.3224 12.4138 10.7896 13.3679 11.2835L13.5865 11.3965L13.2881 14.5525C11.8378 13.8783 10.4974 13.4823 9.24834 13.3693ZM17.0792 19.6483C16.5125 19.3817 15.9342 19.0706 15.3352 18.7482C14.6042 18.3559 13.8675 17.9585 13.1181 17.6272L13.391 14.7391C13.4928 14.7873 13.5946 14.8381 13.6975 14.8889C14.8867 15.4727 16.1304 15.912 17.4065 16.199L17.0792 19.6483ZM17.5314 16.0936L17.8333 12.9199C19.1749 13.1728 20.5318 13.3163 21.8927 13.349L21.5608 16.6624C20.2059 16.5766 18.858 16.3882 17.5268 16.0987L17.5314 16.0936ZM25.715 20.41C25.6757 20.9927 25.6387 21.0143 24.7297 21.0054C24.5227 21.0054 24.2879 21.0054 24.0358 21.013C23.1085 21.0559 22.1796 21.0079 21.2601 20.8695L21.6683 16.7919C23.0724 16.8896 24.4822 16.9188 25.877 16.9429H25.9533L25.715 20.41ZM26.1985 13.2525C25.7601 13.2525 25.3241 13.2525 24.8939 13.2525C23.9421 13.2525 22.981 13.2525 22.0211 13.2233L22.3819 9.61787C22.7 9.62549 23.0215 9.62803 23.3465 9.61787H23.3846C24.3897 9.60264 25.4178 9.58867 26.4437 9.61787L26.1985 13.2525Z" fill="currentColor"/>
        <path d="M3.74202 4.72318C3.6501 4.71165 3.55692 4.71925 3.4678 4.74555C3.37868 4.77185 3.29537 4.81633 3.22263 4.87646C3.14988 4.93659 3.08914 5.01118 3.04386 5.09597C2.99858 5.18077 2.96965 5.2741 2.95873 5.37063L0.594773 26.1852C0.583653 26.2822 0.590934 26.3806 0.616195 26.4746C0.641456 26.5686 0.684197 26.6565 0.741952 26.7331C0.799707 26.8096 0.871333 26.8735 0.952696 26.9208C1.03406 26.9682 1.12355 26.9982 1.216 27.009C1.24377 27.0108 1.27162 27.0108 1.29938 27.009C1.47267 27.0103 1.64033 26.9445 1.77031 26.8241C1.90029 26.7038 1.98349 26.5374 2.00399 26.3567L4.35856 5.55069C4.3702 5.45378 4.36346 5.35541 4.33873 5.26124C4.31399 5.16708 4.27174 5.079 4.21443 5.00207C4.15711 4.92514 4.08586 4.86089 4.00478 4.81302C3.9237 4.76516 3.8344 4.73462 3.74202 4.72318Z" fill="currentColor"/>
        </g>
        </svg>`,
    hourse:`<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M11.7353 2.59491C14.6212 2.59519 17.397 3.70467 19.4903 5.69459C21.5836 7.6845 22.8348 10.4031 22.9859 13.2899C23.3754 13.3414 27.46 13.9082 27.4821 14.8469C27.506 15.8297 23.12 15.9751 23.12 15.9751C23.12 15.9751 14.6954 15.6456 12.2387 16.0947C7.90053 16.8861 6.33136 18.9658 4.04191 19.3836C3.62379 19.4725 3.19314 19.4856 2.7704 19.4223C1.41989 19.38 0.670216 17.9665 0.471773 13.877C0.47226 10.8849 1.6591 8.01557 3.77131 5.89988C5.88351 3.7842 8.74814 2.5954 11.7353 2.59491Z" fill="currentColor"/>
        <path d="M7.20774 18.9742C8.32999 18.3289 9.52451 17.8187 10.7664 17.4542C11.0084 17.3826 11.2321 17.3147 11.4576 17.2523C12.2143 17.0442 12.9942 16.9332 13.7788 16.9218L16.9414 16.8668C16.9414 16.8668 15.8175 17.7296 16.9176 19.837C18.0176 21.9445 17.8343 23.3562 17.8343 23.3562C17.8343 23.3562 17.7775 23.4443 17.684 23.5746L18.2468 25.2029C18.2743 25.2818 18.2859 25.3652 18.281 25.4486C18.2761 25.5319 18.2549 25.6134 18.2184 25.6885C18.1819 25.7636 18.131 25.8307 18.0686 25.886C18.0061 25.9413 17.9333 25.9836 17.8545 26.0107L17.1211 26.2677C16.9623 26.3228 16.7882 26.3125 16.637 26.2392C16.4857 26.1659 16.3697 26.0355 16.3144 25.8767L15.9257 24.7514C15.4729 24.741 15.0343 24.591 14.6698 24.3218C13.8558 23.7472 12.2057 22.6457 11.0029 22.3024C9.95689 22.0154 8.84894 22.0486 7.82194 22.3979C6.9859 22.6861 5.95734 23.3562 4.78578 22.7816C3.61422 22.207 3.30253 20.7219 3.30253 20.362C3.30987 20.362 4.55293 20.5071 7.20774 18.9742ZM11.2083 20.5254C11.575 20.955 13.9163 22.1941 13.9163 22.1941C13.9163 22.1941 14.866 22.7155 15.4233 22.5007C15.9807 22.2859 15.6379 20.9917 15.6379 20.9917L14.921 19.1413C14.921 19.1413 14.4223 17.2376 12.0388 18.1353C9.65537 19.033 10.8306 20.0995 11.2083 20.5254Z" fill="currentColor"/>
        </g>
        </svg>`,
    hokey: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M23.6472 4.58237C21.0588 3.22819 17.6324 2.48203 13.9992 2.47541C10.366 2.46879 6.93955 3.22158 4.35197 4.57493C1.61962 6.00521 0.113228 7.95831 0.113228 10.076L0.1124 17.9223C0.1124 20.0384 1.61879 21.9915 4.35114 23.4218C6.93955 24.7759 10.3668 25.5229 13.9983 25.5213C17.6299 25.5196 21.0579 24.7751 23.6455 23.4218C26.3779 21.9915 27.8843 20.0384 27.8843 17.9223L27.8859 10.0835C27.8859 7.96576 26.3795 6.01266 23.6472 4.58237ZM13.9992 3.88502C20.7659 3.88502 26.4821 6.72408 26.4829 10.0818C26.4829 11.3839 25.616 12.4229 24.8897 13.0648C22.6471 15.0477 18.4745 16.2786 14.0008 16.2786C9.52714 16.2786 5.35457 15.0477 3.11195 13.0648C2.38564 12.4229 1.5187 11.3839 1.5187 10.0818C1.51621 6.72408 7.23239 3.88502 13.9992 3.88502Z" fill="currentColor"/>
        </g>
        </svg>`,
    greyhounds: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M1.7169 13.8645C1.71617 11.0527 2.70452 8.33043 4.50855 6.17528C6.31258 4.02014 8.81708 2.56979 11.5826 2.07869C14.3482 1.58759 17.1982 2.08711 19.6326 3.48961C22.0669 4.89211 23.9303 7.10801 24.8956 9.74855C25.1746 9.83042 25.4658 9.90108 25.7661 9.97286C25.9812 10.0244 26.2019 10.0798 26.4282 10.1388H26.4394C25.4858 6.78236 23.254 3.93488 20.2242 2.20937C17.1944 0.483854 13.609 0.0182822 10.2398 0.91287C6.87052 1.80746 3.98686 3.99067 2.20951 6.99255C0.432161 9.99443 -0.0967433 13.5749 0.736648 16.9633L0.812828 16.8938L1.89166 15.9046C1.77546 15.2308 1.71699 14.5483 1.7169 13.8645V13.8645Z" fill="currentColor"/>
        <path d="M26.3918 15.6736C26.2629 15.7858 26.1038 15.9195 25.8976 16.0665C25.7353 16.1796 25.5644 16.2799 25.3865 16.3663C25.0418 18.0292 24.3482 19.5996 23.3517 20.9735C22.3551 22.3473 21.0784 23.4932 19.6063 24.3352C18.1341 25.1771 16.5001 25.6959 14.8126 25.857C13.1251 26.0182 11.4227 25.8181 9.8183 25.27C9.53141 25.6764 9.25124 26.0705 9.00806 26.4096C10.9102 27.1243 12.9505 27.3931 14.9724 27.1952C16.9944 26.9972 18.9442 26.3379 20.6723 25.2678C22.4004 24.1977 23.8608 22.7452 24.9416 21.0217C26.0224 19.2983 26.6949 17.3497 26.9073 15.3255C26.8737 15.3412 26.8412 15.3558 26.8131 15.3704C26.6594 15.4514 26.5175 15.5534 26.3918 15.6736Z" fill="currentColor"/>
        <path d="M27.3179 11.8701C27.1558 11.7932 26.9881 11.7287 26.8162 11.6772V11.6772C26.5806 11.6032 26.3348 11.5415 26.1204 11.4843H26.1148C26.0026 11.4529 25.8904 11.4237 25.7692 11.3957L25.3697 11.297C24.8088 11.1758 24.2592 11.0073 23.7267 10.7935C22.8188 10.4021 21.7741 10.3943 20.901 9.98606C20.4083 9.75504 19.7922 9.3973 19.4331 8.98798C19.1054 8.61566 18.9617 8.40259 18.5129 8.15699C18.1167 7.94055 17.6925 7.62094 17.2459 7.52562C16.8419 7.43927 16.3122 7.52562 15.8992 7.52562C14.3707 7.52562 12.7356 7.36638 11.3418 8.09643C11.0051 8.2725 10.6382 8.64594 10.2903 8.7693C10.0445 8.85341 9.63939 8.80518 9.38576 8.82761C8.21528 8.93078 6.3737 8.93976 5.65547 10.1027C5.47143 10.3987 5.40858 10.7913 5.238 11.112C5.03376 11.4765 3.95305 12.4555 4.1775 12.9523C4.46254 13.6038 6.53418 13.1328 7.06948 13.0173L1.69737 17.9348C1.64372 17.9808 1.5924 18.0295 1.54362 18.0806C1.50996 18.1165 1.47853 18.1535 1.44823 18.1927C1.43589 18.2073 1.42355 18.2197 1.41232 18.2342C1.37417 18.2825 1.33826 18.3329 1.3001 18.3845C1.30042 18.3867 1.30042 18.389 1.3001 18.3912C1.25244 18.4635 1.20898 18.5383 1.16992 18.6155C2.36691 21.7616 4.70111 24.3446 7.7114 25.8544C8.68661 24.5087 10.591 21.7668 10.6696 21.7477C10.8705 21.6995 11.2689 21.0255 11.3867 20.882C12.0959 20.0207 12.748 19.0877 13.4864 18.2511C14.2035 17.4436 15.3616 16.9345 16.292 16.4276C17.798 15.6112 19.6586 15.4654 21.342 15.591C22.205 15.6561 22.8862 15.8209 23.7391 15.5394C24.1723 15.3959 24.7704 15.194 25.1385 14.9338C25.3394 14.7914 25.4864 14.658 25.639 14.5301L25.694 14.4853L25.7052 14.4752L25.7535 14.437L25.7714 14.4236L25.8174 14.3877L25.8388 14.372L25.8837 14.3395L25.9083 14.3227L25.9544 14.2913L25.9824 14.2733L26.0318 14.243L26.061 14.2251L26.116 14.1937L26.1451 14.178L26.2293 14.1343H26.236C26.291 14.1062 26.3483 14.0804 26.4055 14.0546C26.6102 13.9717 26.809 13.8746 27.0003 13.7642V13.7642C27.0683 13.7228 27.1325 13.6756 27.1922 13.6229C27.668 13.1979 28.0484 12.2323 27.3179 11.8701Z" fill="currentColor"/>
        </g>
        </svg>`,
    golf: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M14.0006 4.97069e-08C11.2315 -0.000233236 8.52446 0.820689 6.22192 2.35895C3.91938 3.89722 2.12471 6.08373 1.06486 8.64198C0.00500322 11.2002 -0.272423 14.0153 0.267659 16.7313C0.807742 19.4472 2.14108 21.942 4.09905 23.9001C6.05702 25.8582 8.55168 27.1918 11.2676 27.7321C13.9834 28.2724 16.7986 27.9952 19.3569 26.9356C21.9152 25.8759 24.1019 24.0814 25.6404 21.779C27.1788 19.4766 28 16.7697 28 14.0006C27.9956 10.289 26.5193 6.73056 23.8949 4.10592C21.2705 1.48128 17.7122 0.00468232 14.0006 4.97069e-08V4.97069e-08ZM14.0006 1.41539C15.8569 1.41609 17.6901 1.82732 19.3689 2.61963C21.0476 3.41194 22.5304 4.56571 23.7109 5.9983C24.8915 7.43089 25.7406 9.10683 26.1974 10.9061C26.6542 12.7053 26.7075 14.5833 26.3534 16.4056C25.6351 16.9729 24.7387 16.4587 24.7387 16.4587C24.7387 16.4587 23.6995 15.9739 22.9848 16.7594C22.27 17.545 22.592 18.5358 22.1072 19.0665C21.6224 19.5973 20.8098 19.4817 20.1233 19.0205C19.4368 18.5593 18.9002 18.4898 18.531 18.6973C18.2078 18.879 17.7053 19.8768 17.5874 20.1198C17.5677 20.1598 17.5436 20.1974 17.5154 20.2319C17.3763 20.4053 16.9257 20.9124 16.4067 20.9124C15.9243 20.9124 15.4289 20.3616 15.2272 20.1104C15.1286 19.9862 15.0122 19.8773 14.8816 19.7872C14.4794 19.5124 13.6385 19.129 12.8965 19.9901C11.5991 21.4975 10.337 20.995 10.1047 19.6893C9.65058 18.2822 8.73647 18.1996 7.40719 19.2977C6.35272 19.9417 5.74528 19.0335 5.58251 18.7386C5.55431 18.6861 5.53404 18.6296 5.52235 18.5711L5.44569 17.9201C5.42799 17.7632 5.41502 17.0284 4.93851 16.5518C4.49266 16.1048 3.99491 16.198 3.3226 16.3159C2.8508 16.3985 2.16552 16.6887 1.6489 16.4162C1.29324 14.5933 1.3453 12.7143 1.80134 10.9139C2.25738 9.11352 3.10611 7.43632 4.28667 6.00256C5.46723 4.5688 6.95038 3.41398 8.6298 2.62092C10.3092 1.82785 12.1433 1.41617 14.0006 1.41539V1.41539ZM5.46456 20.7792C5.89448 21.0467 6.36669 21.2393 6.86108 21.3488C6.63597 21.638 6.31278 21.8346 5.95255 21.9017C5.59232 21.9687 5.22 21.9015 4.90594 21.7128C4.59188 21.524 4.35783 21.2268 4.248 20.8772C4.13816 20.5276 4.16016 20.15 4.30984 19.8155C4.63781 20.1994 5.0282 20.5252 5.46456 20.7792V20.7792ZM23.7267 19.7707C23.8775 20.1054 23.9003 20.4839 23.7907 20.8343C23.681 21.1847 23.4466 21.4827 23.1319 21.6717C22.8172 21.8608 22.444 21.9278 22.0832 21.86C21.7223 21.7922 21.3989 21.5944 21.1742 21.304C21.6684 21.1951 22.1406 21.0033 22.5708 20.7367C23.0073 20.4816 23.3981 20.155 23.7267 19.7707V19.7707ZM22.7382 18.4438C23.7072 18.1344 24.5543 17.5283 25.1597 16.7111C25.3369 17.0327 25.3898 17.408 25.3086 17.7661C25.2273 18.1241 25.0176 18.4399 24.719 18.6535C24.4204 18.8671 24.0538 18.9638 23.6887 18.9251C23.3237 18.8865 22.9854 18.7152 22.7382 18.4438V18.4438ZM21.4408 22.3361C21.4935 22.6856 21.4209 23.0426 21.2359 23.3438C21.051 23.6451 20.7655 23.8713 20.4299 23.9825C20.0944 24.0936 19.7303 24.0827 19.4021 23.9515C19.0738 23.8203 18.8025 23.5774 18.636 23.2655C18.859 23.4651 19.1306 23.6024 19.4236 23.6636C19.7166 23.7248 20.0205 23.7077 20.3047 23.6141C20.589 23.5205 20.8436 23.3536 21.0428 23.1303C21.242 22.9069 21.3789 22.635 21.4396 22.342L21.4408 22.3361ZM19.5878 21.1354C19.2386 21.2501 18.8594 21.2327 18.5222 21.0864C18.1849 20.9401 17.9132 20.675 17.7584 20.3416C18.7762 20.3343 19.7661 20.0085 20.5892 19.4098C20.6642 19.771 20.6035 20.1472 20.4188 20.4665C20.2341 20.7859 19.9383 21.0261 19.5878 21.1413V21.1354ZM18.3576 21.9386C18.3724 22.3081 18.2501 22.67 18.0142 22.9548C17.7783 23.2396 17.4455 23.4272 17.0797 23.4815C16.7139 23.5357 16.341 23.4529 16.0326 23.2489C15.7242 23.0449 15.502 22.7341 15.4089 22.3762C16.4133 22.5434 17.445 22.3903 18.3576 21.9386ZM15.4832 23.7302C15.4211 24.0761 15.2394 24.3891 14.9699 24.6145C14.7003 24.8399 14.3602 24.9634 14.0088 24.9634C13.6575 24.9634 13.3173 24.8399 13.0478 24.6145C12.7783 24.3891 12.5966 24.0761 12.5344 23.7302C12.6838 23.9892 12.8987 24.2042 13.1575 24.3537C13.4163 24.5032 13.7099 24.5819 14.0088 24.5819C14.3077 24.5819 14.6013 24.5032 14.8601 24.3537C15.119 24.2042 15.3338 23.9892 15.4832 23.7302V23.7302ZM13.918 22.0153C13.5503 22.0154 13.1954 21.8804 12.9207 21.636C12.6461 21.3916 12.4708 21.0547 12.4283 20.6895C13.3966 21.0009 14.4382 21.0009 15.4065 20.6895C15.364 21.0545 15.1889 21.3912 14.9145 21.6356C14.6401 21.88 14.2855 22.0151 13.918 22.0153V22.0153ZM12.6205 22.4234C12.5274 22.7814 12.3052 23.0923 11.9966 23.2964C11.6881 23.5005 11.315 23.5832 10.9491 23.5288C10.5831 23.4743 10.2503 23.2865 10.0145 23.0015C9.77873 22.7164 9.65667 22.3542 9.67181 21.9846C10.1222 22.2148 10.6084 22.3672 11.1096 22.4352C11.6103 22.5169 12.1212 22.5129 12.6205 22.4234V22.4234ZM8.40622 21.1719C8.05708 21.0568 7.76242 20.8174 7.57823 20.4993C7.39404 20.1811 7.33317 19.8064 7.40719 19.4463C7.81226 19.7495 8.26568 19.982 8.74827 20.134C9.22671 20.2987 9.7296 20.3813 10.2356 20.3781C10.0809 20.7116 9.80911 20.9766 9.47188 21.1229C9.13466 21.2693 8.75544 21.2867 8.40622 21.1719V21.1719ZM7.68791 23.6489C7.97262 23.7421 8.2769 23.7585 8.56997 23.6963C8.86305 23.6342 9.13451 23.4958 9.35689 23.295C9.18985 23.6049 8.91909 23.8461 8.59207 23.9764C8.26504 24.1066 7.90259 24.1177 7.56824 24.0075C7.23389 23.8974 6.94897 23.6731 6.76339 23.374C6.57781 23.0748 6.50341 22.7199 6.55323 22.3715C6.61355 22.6649 6.75022 22.9371 6.94945 23.1608C7.14868 23.3845 7.40341 23.5516 7.68791 23.6453V23.6489ZM3.27306 18.695C2.9715 18.4812 2.75954 18.1636 2.6779 17.8031C2.59627 17.4425 2.6507 17.0646 2.83075 16.7417C3.1261 17.154 3.48946 17.513 3.90527 17.8033C4.3129 18.103 4.76833 18.3315 5.25225 18.4791C5.00498 18.7501 4.6669 18.9208 4.30211 18.9591C3.93732 18.9974 3.57116 18.9004 3.27306 18.6867V18.695Z" fill="currentColor"/>
        <path d="M13.957 17.1027C14.1576 17.1026 14.3522 17.1707 14.5089 17.2959C14.6656 17.4211 14.775 17.5958 14.8192 17.7915C14.8266 17.747 14.8306 17.7021 14.831 17.657C14.831 17.4224 14.7378 17.1974 14.5719 17.0315C14.406 16.8656 14.181 16.7724 13.9464 16.7724C13.7118 16.7724 13.4868 16.8656 13.3209 17.0315C13.155 17.1974 13.0618 17.4224 13.0618 17.657C13.062 17.7229 13.0695 17.7886 13.0842 17.8528C13.116 17.6441 13.2216 17.4537 13.3817 17.3161C13.5418 17.1785 13.7459 17.1028 13.957 17.1027V17.1027Z" fill="currentColor"/>
        <path d="M9.98326 16.5188C10.1737 16.5815 10.3371 16.7071 10.4469 16.8749C10.5566 17.0427 10.606 17.2428 10.5872 17.4423C10.6076 17.402 10.6249 17.3602 10.6391 17.3173C10.6862 17.2048 10.7096 17.0838 10.7077 16.9618C10.7059 16.8399 10.6788 16.7196 10.6283 16.6086C10.5777 16.4976 10.5047 16.3983 10.4139 16.3168C10.3231 16.2354 10.2165 16.1736 10.1006 16.1353C9.98483 16.0971 9.86235 16.0832 9.74091 16.0945C9.61946 16.1059 9.50167 16.1422 9.39495 16.2013C9.28822 16.2603 9.19486 16.3408 9.12073 16.4377C9.04659 16.5345 8.99329 16.6457 8.96417 16.7641C8.94338 16.8268 8.92992 16.8918 8.92407 16.9576C9.01942 16.7703 9.1785 16.6231 9.37268 16.5427C9.56686 16.4622 9.78338 16.4538 9.98326 16.5188Z" fill="currentColor"/>
        <path d="M6.16628 14.7153C6.32927 14.832 6.4478 15.0006 6.50244 15.1935C6.55709 15.3863 6.54461 15.592 6.46705 15.7769C6.49859 15.7448 6.52776 15.7105 6.55434 15.6743C6.62816 15.5731 6.67967 15.4575 6.70547 15.335C6.73127 15.2125 6.73078 15.0859 6.70401 14.9636C6.67724 14.8413 6.62482 14.726 6.5502 14.6255C6.47558 14.5249 6.38048 14.4414 6.27116 14.3803C6.16185 14.3193 6.04083 14.2822 5.91609 14.2714C5.79135 14.2606 5.66575 14.2764 5.54757 14.3177C5.4294 14.3591 5.32136 14.4251 5.23058 14.5113C5.13981 14.5975 5.06837 14.7021 5.021 14.818C5.16823 14.667 5.36461 14.5736 5.57466 14.5548C5.78471 14.536 5.99456 14.5929 6.16628 14.7153V14.7153Z" fill="currentColor"/>
        <path d="M2.99124 11.6558C3.12105 11.8085 3.19513 12.0008 3.20135 12.2012C3.20756 12.4016 3.14554 12.5981 3.02544 12.7586C3.1301 12.6951 3.22045 12.6107 3.29078 12.5105C3.36111 12.4103 3.40989 12.2966 3.43403 12.1767C3.45817 12.0567 3.45714 11.933 3.43103 11.8134C3.40491 11.6938 3.35426 11.581 3.28228 11.482C3.21031 11.383 3.11858 11.3 3.01288 11.2383C2.90719 11.1766 2.78984 11.1374 2.66826 11.1234C2.54667 11.1094 2.4235 11.1207 2.30652 11.1567C2.18954 11.1927 2.08131 11.2526 1.98867 11.3326C1.93838 11.3755 1.8929 11.4238 1.85303 11.4765C2.03295 11.3657 2.24655 11.3229 2.45527 11.3558C2.66399 11.3887 2.85408 11.4951 2.99124 11.6558V11.6558Z" fill="currentColor"/>
        <path d="M11.4754 19.1078C11.8656 19.1486 12.2426 19.2729 12.5805 19.4722C12.6018 18.7233 12.1878 18.0911 11.6027 18.0227C11.0177 17.9542 10.4681 18.4732 10.3159 19.2021C10.691 19.0872 11.0866 19.055 11.4754 19.1078Z" fill="currentColor"/>
        <path d="M5.85962 17.3268C6.24684 17.3905 6.61553 17.5378 6.94004 17.7585C7.27178 17.9707 7.55348 18.2524 7.76568 18.5841C8.11953 17.9248 8.03461 17.1687 7.54276 16.8491C7.05091 16.5294 6.32552 16.7394 5.85962 17.3268Z" fill="currentColor"/>
        <path d="M1.88721 14.2872C2.26247 14.4017 2.60852 14.596 2.90157 14.8569C3.20106 15.1103 3.44243 15.4253 3.60927 15.7804C4.04804 15.173 4.06102 14.4181 3.61635 14.0312C3.17168 13.6444 2.42388 13.767 1.88721 14.2872Z" fill="currentColor"/>
        <path d="M17.5874 19.2175C17.4341 18.4838 16.8797 17.9649 16.3006 18.038C15.7215 18.1111 15.3016 18.7386 15.3228 19.4888C15.6626 19.2934 16.0385 19.169 16.4278 19.1232C16.817 19.0774 17.2116 19.1111 17.5874 19.2222V19.2175Z" fill="currentColor"/>
        <path d="M20.9621 17.7738C21.2871 17.5533 21.6561 17.406 22.0437 17.3421C21.5778 16.7523 20.8536 16.5377 20.3617 16.8608C19.8699 17.184 19.7838 17.9365 20.1388 18.5959C20.3509 18.2658 20.6317 17.9854 20.9621 17.7738V17.7738Z" fill="currentColor"/>
        <path d="M25.0052 14.8722C25.2988 14.6115 25.6452 14.4172 26.0207 14.3025C25.4817 13.7824 24.7362 13.6609 24.2904 14.0478C23.8446 14.4346 23.8587 15.1883 24.2975 15.7958C24.4642 15.4406 24.7056 15.1256 25.0052 14.8722V14.8722Z" fill="currentColor"/>
        <path d="M17.2583 17.5544C17.2385 17.3493 17.2909 17.1438 17.4066 16.9733C17.5222 16.8028 17.6938 16.6781 17.8916 16.6208C18.0895 16.5634 18.3012 16.577 18.4901 16.6591C18.679 16.7413 18.8332 16.8869 18.9261 17.0708C18.9203 17.005 18.9068 16.9401 18.886 16.8773C18.8525 16.7636 18.7965 16.6578 18.7214 16.5662C18.6462 16.4746 18.5533 16.399 18.4484 16.3439C18.3434 16.2888 18.2284 16.2554 18.1103 16.2457C17.9922 16.2359 17.8733 16.25 17.7607 16.2871C17.6481 16.3242 17.5442 16.3835 17.455 16.4615C17.3657 16.5396 17.2931 16.6348 17.2414 16.7414C17.1897 16.8481 17.16 16.964 17.154 17.0824C17.148 17.2008 17.1658 17.3192 17.2064 17.4305C17.2203 17.4731 17.2377 17.5146 17.2583 17.5544V17.5544Z" fill="currentColor"/>
        <path d="M21.3782 15.8901C21.2978 15.7003 21.2863 15.4884 21.3457 15.291C21.405 15.0936 21.5315 14.9232 21.7033 14.8093C21.8751 14.6953 22.0813 14.645 22.2862 14.6671C22.4911 14.6891 22.6819 14.7821 22.8255 14.93C22.7999 14.8694 22.7679 14.8116 22.73 14.7578C22.6623 14.6633 22.5768 14.5831 22.4782 14.5217C22.3795 14.4602 22.2698 14.4189 22.1552 14.3999C22.0405 14.3809 21.9233 14.3846 21.8101 14.4109C21.697 14.4372 21.5901 14.4856 21.4956 14.5532C21.4011 14.6208 21.3209 14.7063 21.2595 14.805C21.198 14.9036 21.1566 15.0133 21.1376 15.128C21.1186 15.2426 21.1224 15.3598 21.1487 15.473C21.175 15.5861 21.2234 15.693 21.291 15.7875C21.3178 15.8235 21.347 15.8578 21.3782 15.8901Z" fill="currentColor"/>
        <path d="M24.7105 12.7928C24.745 12.8215 24.7817 12.8475 24.8202 12.8707C24.6965 12.7059 24.6343 12.5031 24.6444 12.2974C24.6544 12.0916 24.736 11.8959 24.8751 11.7439C25.0142 11.592 25.202 11.4934 25.406 11.4652C25.6101 11.4371 25.8175 11.4811 25.9926 11.5897C25.9533 11.5351 25.9078 11.4852 25.8569 11.4411C25.7689 11.3629 25.6662 11.303 25.5547 11.2649C25.4432 11.2269 25.3253 11.2116 25.2078 11.2197C25.0903 11.2279 24.9756 11.2594 24.8705 11.3125C24.7653 11.3656 24.6718 11.4392 24.5955 11.5288C24.5192 11.6185 24.4615 11.7226 24.4259 11.8348C24.3903 11.9471 24.3775 12.0654 24.3882 12.1826C24.3989 12.2999 24.4329 12.4139 24.4883 12.5179C24.5436 12.6218 24.6192 12.7137 24.7105 12.7881V12.7928Z" fill="currentColor"/>
        </g>
        </svg>`,
    gaa: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M27.954 19.8828V19.9974C27.5779 19.9974 27.2009 20.0066 26.8248 19.9974C26.6502 19.9904 26.4766 19.962 26.3069 19.9126C25.6936 19.7407 25.2269 19.2902 24.8411 18.7286C24.5326 18.2793 24.2625 17.7899 23.98 17.3189C23.9511 17.2719 23.9192 17.2283 23.8836 17.1687C23.8431 17.2317 23.8112 17.2764 23.7871 17.3246C23.4255 17.9424 23.061 18.5567 22.6 19.0794C22.2676 19.4682 21.8648 19.7618 21.4225 19.9378C20.9802 20.1138 20.5099 20.1675 20.0475 20.0949C19.1371 19.9802 18.4255 19.4072 17.8575 18.5865C17.5807 18.1853 17.3522 17.7372 17.1024 17.3085C17.006 17.1481 17.006 17.1492 16.9095 17.3085C16.5238 17.9607 16.1381 18.6175 15.6395 19.1584C14.9336 19.9195 14.0966 20.2072 13.166 20.0926C12.4726 20.0066 11.894 19.6146 11.3897 19.061C10.9411 18.5421 10.552 17.9552 10.2325 17.3154C10.2084 17.2696 10.1804 17.2283 10.1438 17.1676C10.1042 17.2226 10.0734 17.2615 10.0474 17.3039C9.76842 17.7644 9.45151 18.1906 9.10135 18.5762C8.4733 19.2621 7.71082 19.7503 6.88339 19.9963C6.65388 20.0628 6.42051 20.1109 6.18907 20.1694H4.61239C4.53235 20.1499 4.45328 20.1304 4.37324 20.1132C3.35613 19.9037 2.41544 19.3359 1.67311 18.4833C0.890903 17.5937 0.353095 16.4439 0.130185 15.1847C0.0742534 14.8833 0.0424305 14.5853 0 14.2895V13.0998C0.00867897 13.046 0.0192866 12.9921 0.0250726 12.9371C0.184187 11.4092 0.706854 10.0969 1.65768 9.03211C2.35931 8.25188 3.22581 7.71238 4.16494 7.47104C4.42435 7.40341 4.69436 7.36559 4.96148 7.31287H5.94027C5.98174 7.32204 6.02321 7.33464 6.06564 7.34152C7.62303 7.59482 8.82169 8.48768 9.59605 10.1382C9.66741 10.2917 9.65873 10.3192 9.51601 10.3376C9.13028 10.3892 8.74454 10.4407 8.35881 10.4809C8.32975 10.4775 8.30156 10.4672 8.27589 10.4507C8.25022 10.4341 8.22759 10.4117 8.20934 10.3846C8.11291 10.2574 8.03962 10.1072 7.94029 9.98686C7.53817 9.49974 7.03672 9.22925 6.48512 9.08254C5.78598 8.89801 5.09552 8.90603 4.43592 9.28885C3.66445 9.737 3.20543 10.5003 2.91806 11.439C2.67008 12.2771 2.59533 13.1738 2.70012 14.0534C2.80524 15.0563 3.03957 16.0019 3.53331 16.842C3.88944 17.483 4.41037 17.9698 5.01837 18.23C5.79055 18.5461 6.63286 18.5192 7.38966 18.1544C7.88754 17.9358 8.33586 17.5827 8.69922 17.1229C8.95766 16.7939 9.16885 16.4134 9.40415 16.0592C9.41834 16.0423 9.42949 16.0221 9.43691 15.9999C9.44434 15.9776 9.44789 15.9538 9.44735 15.9299C9.44681 15.906 9.44219 15.8825 9.43376 15.8608C9.42534 15.8391 9.4133 15.8196 9.39836 15.8036C9.05358 15.2799 8.62733 14.8398 8.1428 14.5073C7.6957 14.1947 7.19357 14.0099 6.67606 13.9675C6.59819 13.9683 6.52152 13.9446 6.45379 13.899C6.38607 13.8533 6.32968 13.7872 6.29032 13.7073C6.23922 13.611 6.25175 13.5663 6.34143 13.5423C6.3829 13.5319 6.42437 13.517 6.46583 13.5067C7.30782 13.2839 8.17173 13.201 9.03288 13.2603C9.5864 13.305 10.1178 13.4334 10.599 13.7772C10.6954 13.8414 10.7465 13.8139 10.8024 13.7165C10.948 13.4609 11.0985 13.2087 11.2479 12.9554C11.815 11.9972 12.3826 11.039 12.951 10.0808C12.9809 10.0417 12.9985 9.99137 13.0008 9.93852C13.0031 9.88566 12.9899 9.83349 12.9635 9.79087C12.7513 9.43326 12.5585 9.05732 12.3251 8.7215C12.0947 8.38454 11.7747 8.15089 11.4177 8.05902C11.3518 8.04744 11.2887 8.01977 11.2322 7.97775C11.1758 7.93573 11.1273 7.88028 11.0898 7.81488C11.0011 7.66015 11.0011 7.64181 11.1554 7.61316C11.6582 7.52093 12.1663 7.47494 12.6752 7.47562C13.3559 7.48146 14.0177 7.74259 14.5662 8.22177C15.0534 8.63726 15.4702 9.15834 15.7948 9.75763C16.4495 10.9301 17.0976 12.1073 17.7495 13.2821C17.7716 13.3233 17.7977 13.36 17.8324 13.4162C17.87 13.3623 17.898 13.3268 17.9221 13.2867C18.005 13.1468 18.086 13.0058 18.1689 12.8672C18.7212 11.9388 19.2725 11.0111 19.8228 10.0843C19.8536 10.0454 19.872 9.99483 19.8749 9.94146C19.8777 9.88808 19.8647 9.83522 19.8382 9.79201C19.6569 9.47567 19.493 9.14329 19.2934 8.84528C19.0426 8.44432 18.6793 8.16336 18.2692 8.05329C18.2123 8.04158 18.158 8.01637 18.1094 7.97915C18.0609 7.94193 18.0191 7.89347 17.9867 7.83666C17.8854 7.66818 17.8902 7.64411 18.0687 7.60743C18.585 7.49798 19.1098 7.45571 19.6338 7.48135C19.9125 7.49538 20.1889 7.54808 20.4573 7.63838C21.3715 7.97191 22.0619 8.67909 22.5856 9.60404C23.0793 10.4763 23.5287 11.3852 23.9935 12.2792C25.1732 14.5486 26.3516 16.818 27.5287 19.0874C27.6676 19.3567 27.8122 19.6192 27.954 19.8828ZM21.7823 18.0272C21.8932 18.0272 21.9983 18.0341 22.0716 17.9045C22.4207 17.2994 22.7714 16.6965 23.1237 16.0959C23.156 16.0499 23.1737 15.9919 23.1737 15.932C23.1737 15.8721 23.156 15.8141 23.1237 15.7681C22.7379 15.0724 22.3522 14.3709 21.9665 13.6729C21.53 12.8767 21.0938 12.0809 20.6579 11.2855C20.5759 11.1365 20.5663 11.1319 20.4766 11.2855C20.2287 11.6981 19.9838 12.1141 19.7379 12.529C19.3522 13.1801 18.9664 13.8334 18.5749 14.4775C18.5455 14.5143 18.5281 14.5623 18.5258 14.6129C18.5235 14.6635 18.5365 14.7134 18.5624 14.7537C19.0086 15.5522 19.4534 16.3545 19.897 17.1607C20.0303 17.4007 20.2164 17.5926 20.4351 17.7154C20.8633 17.9607 21.3242 17.9905 21.7852 18.0272H21.7823ZM15.0088 18.057C15.077 18.0163 15.1392 17.9629 15.193 17.8988C15.5604 17.2868 15.9201 16.669 16.2846 16.0546C16.3069 16.0197 16.3182 15.9766 16.3164 15.9328C16.3147 15.889 16.3 15.8473 16.275 15.8151C15.9343 15.2038 15.5951 14.5925 15.2576 13.9812L13.7668 11.2671C13.6973 11.1422 13.6829 11.1399 13.6057 11.2671C12.9526 12.369 12.3 13.47 11.6481 14.5704C11.6251 14.6009 11.613 14.641 11.6146 14.6819C11.6163 14.7229 11.6314 14.7615 11.6568 14.7893C11.8143 15.03 11.967 15.2745 12.1149 15.5228C12.4717 16.1211 12.8208 16.7251 13.2981 17.2054C13.7808 17.6943 14.3799 17.992 15.0117 18.057H15.0088Z" fill="currentColor"/>
        </g>
        </svg>`,
    darts: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M21.2416 9.76794C20.6935 10.3893 20.1659 10.9869 19.6794 11.5353C22.9965 14.0715 24.6092 17.7997 23.3693 20.8987C21.7692 24.8947 16.0353 26.361 10.5843 24.164C5.1332 21.967 2.00092 16.9311 3.59944 12.9334C5.19796 8.93575 10.9334 7.4711 16.3844 9.66649C16.7003 9.79541 17.0084 9.93279 17.3085 10.0786C17.7934 9.53334 18.3289 8.93258 18.888 8.30328C18.3552 8.0243 17.8029 7.76857 17.2311 7.53609C10.2304 4.71299 2.84915 6.62464 0.779918 11.7969C-1.28931 16.9691 2.72594 23.4729 9.73131 26.296C16.7367 29.1191 24.1196 27.2058 26.1888 22.0336C27.8221 17.9535 25.6644 13.0444 21.2416 9.76794Z" fill="currentColor"/>
        <path d="M16.3104 11.4594L15.7599 12.0772L14.7437 13.2974C12.1096 12.3882 9.42878 13.1206 8.66323 15.0116C7.86764 16.9767 9.43336 19.4636 12.1638 20.5431C14.8943 21.6226 17.7584 20.9103 18.554 18.9435C19.1195 17.5478 18.491 15.8917 17.1026 14.6607L17.8014 13.8895C18.0496 13.6169 18.3535 13.2828 18.7004 12.8983C21.1842 14.8729 22.349 17.7096 21.3942 20.0734C20.1245 23.2079 15.5992 24.3678 11.3046 22.6611C7.00999 20.9544 4.55003 17.0161 5.82138 13.8816C7.09273 10.7471 11.6165 9.58567 15.9126 11.2924C16.0479 11.346 16.18 11.4027 16.3104 11.4594Z" fill="currentColor"/>
        <path d="M14.1036 14.6638C12.7314 14.2953 11.3874 14.7344 10.9792 15.7505C10.527 16.8765 11.3921 18.2879 12.9088 18.8963C14.4255 19.5048 16.027 19.0829 16.4808 17.9554C16.7948 17.1603 16.4604 16.2304 15.6957 15.5294L14.3392 16.8734C14.1922 17.019 13.9935 17.1007 13.7865 17.1008C13.639 17.1007 13.4946 17.0591 13.3697 16.9808C13.2448 16.9026 13.1445 16.7908 13.0803 16.6582C13.0161 16.5257 12.9905 16.3777 13.0066 16.2314C13.0226 16.085 13.0796 15.9461 13.171 15.8305L14.1036 14.6638Z" fill="currentColor"/>
        <path d="M27.9496 3.35692C27.9265 3.1609 27.8446 2.97714 27.7152 2.83122C27.5857 2.6853 27.4153 2.58447 27.2275 2.54274C26.7386 2.42099 26.2361 2.36624 25.7332 2.37991C25.6845 1.86477 25.5704 1.35839 25.3939 0.873674C25.331 0.687627 25.2133 0.526303 25.0572 0.412038C24.9011 0.297774 24.7143 0.23622 24.5227 0.235901C24.0976 0.246757 23.5537 0.558859 23.0706 1.76384C22.6802 2.76331 22.5233 3.84297 22.6125 4.91607C22.6125 4.91607 22.6125 4.92693 22.6125 4.93236C22.6125 4.93779 22.6125 4.96221 22.6125 4.97714C22.6118 4.98662 22.6118 4.99615 22.6125 5.00563C22.6125 5.03549 22.6204 5.06398 22.627 5.09384C22.6336 5.12369 22.6376 5.1454 22.6455 5.17118C22.6484 5.18357 22.6519 5.1958 22.656 5.20782C22.6713 5.25457 22.6903 5.29996 22.7128 5.34352C20.2733 7.9706 16.8027 11.9899 15.5592 13.4419C15.3546 13.6807 15.2714 13.9643 15.3322 14.1543L13.3282 16.7488L15.6199 14.4135C15.8074 14.446 16.0622 14.3293 16.2628 14.1C17.5235 12.663 21.0336 8.63959 23.2989 5.83474C23.3233 5.84116 23.348 5.84614 23.3729 5.84967L23.4098 5.85781L23.4864 5.86731C23.5154 5.86731 23.5445 5.86731 23.5735 5.86731H23.6012H23.6448H23.6606C24.7073 5.82876 25.7305 5.53827 26.648 5.0192C27.7556 4.38279 27.9906 3.78979 27.9496 3.35692Z" fill="currentColor"/>
        </g>
        </svg>`,
    cricket: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M17.6437 27.5375C20.5439 26.7644 23.1167 25.0747 24.9785 22.7204C25.147 22.5088 25.3088 22.2915 25.4639 22.0686C25.7007 21.7338 25.9212 21.3897 26.1265 21.034C26.2953 20.7417 26.4559 20.4447 26.6032 20.1401C27.7817 17.7257 28.2407 15.0232 27.9254 12.3551C27.61 9.68705 26.5336 7.16607 24.8246 5.09308C23.1156 3.0201 20.8462 1.48269 18.2873 0.664348C15.7284 -0.153995 12.9881 -0.218699 10.3934 0.477957C9.99902 0.583639 9.61299 0.705509 9.23534 0.843565C9.00195 0.926837 8.77072 1.01817 8.54386 1.11611C8.0558 1.32136 7.58016 1.55496 7.11937 1.81572L7.0931 1.83054C4.12758 3.51188 1.87698 6.21703 0.763085 9.439C-0.350812 12.661 -0.251537 16.1786 1.0423 19.3326C2.33614 22.4866 4.73574 25.0605 7.79136 26.5719C10.847 28.0833 14.3489 28.4284 17.6408 27.5427L17.6437 27.5375ZM22.2598 23.5258C20.5654 17.0083 17.5302 11.9964 13.2339 8.60966C10.9433 6.79622 8.2939 5.48948 5.46087 4.77577C5.63284 4.61479 5.80873 4.45881 5.9906 4.309C6.20229 4.38449 6.41891 4.44536 6.63893 4.4912C14.8807 6.44407 20.4962 12.8232 22.8826 22.9451C22.6819 23.144 22.4747 23.3378 22.2606 23.5221L22.2598 23.5258ZM26.1792 10.7492C26.8138 13.1061 26.7449 15.5972 25.9812 17.9155C24.2173 12.264 21.3589 7.85703 17.4632 4.78882C15.758 3.44004 13.8516 2.36739 11.8137 1.61004C14.9172 1.06173 18.1135 1.6959 20.7726 3.38757C23.4316 5.07924 25.3606 7.70568 26.1792 10.7492V10.7492ZM10.083 2.04702C17.6207 4.27062 22.8862 10.2105 25.4178 19.3398C25.279 19.6344 25.1289 19.9252 24.9697 20.208C23.1718 14.0655 20.1453 9.28887 15.9526 5.98923C13.9348 4.39049 11.6464 3.16703 9.19616 2.37709C9.48417 2.25586 9.77944 2.14564 10.084 2.04761L10.083 2.04702ZM1.85585 17.2651C1.31213 15.2326 1.28652 13.0962 1.78136 11.0513C2.2762 9.0063 3.27571 7.11798 4.68851 5.55894V5.55894C13.1338 7.56528 18.9171 13.9936 21.454 24.1711C19.8026 25.3793 17.8816 26.1668 15.8573 26.4654C13.833 26.764 11.7664 26.5647 9.83652 25.8847C7.9066 25.2047 6.17151 24.0646 4.78145 22.563C3.39139 21.0613 2.38826 19.2435 1.85891 17.2669L1.85585 17.2651Z" fill="currentColor"/>
        </g>
        </svg>`,
    boxing: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M25.8572 13.9423C29.4052 9.50428 25.8047 6.05854 25.3794 5.683C25.3376 5.64118 25.2957 5.59935 25.2539 5.55752L21.6259 1.92936C20.2955 0.606057 18.8967 -0.0204413 17.4559 0.0641004C15.2713 0.193138 13.8724 1.92491 13.8128 1.99877L13.6357 2.2346C11.7438 1.27883 10.5007 1.86706 10.0148 2.20167C8.77868 2.99008 7.70116 4.00306 6.83797 5.18821L6.81661 5.21847C5.9543 6.54443 5.57211 8.12573 5.73364 9.69917L6.08958 13.2588L0.833097 18.5155C0.490873 18.8582 0.298581 19.3227 0.298414 19.8071C0.298247 20.2914 0.490221 20.756 0.832209 21.0989L7.1868 27.4538C7.52973 27.7958 7.99432 27.9878 8.47863 27.9876C8.96294 27.9874 9.42741 27.7951 9.7701 27.4529L15.2499 21.9728C16.2324 21.3891 17.0902 20.896 17.8493 20.4591C21.4043 18.415 23.0257 17.4806 25.8572 13.9423ZM8.25553 26.3832L1.90451 20.0319C1.84542 19.9724 1.81234 19.8918 1.81251 19.8079C1.81267 19.724 1.84608 19.6436 1.9054 19.5843L7.05955 14.4299L13.8609 21.2315L12.9685 22.1239L8.07694 17.2322C7.70386 16.8591 7.09899 16.8591 6.72592 17.2322L4.50943 19.4488C4.13636 19.8219 4.13636 20.4268 4.50943 20.7999L9.40098 25.6916L8.7067 26.3859C8.67741 26.4154 8.64258 26.4389 8.60421 26.4549C8.56583 26.4709 8.52467 26.4792 8.48308 26.4793C8.4415 26.4794 8.4003 26.4713 8.36186 26.4554C8.32343 26.4395 8.2885 26.4162 8.25909 26.3868L8.25553 26.3832ZM17.0947 19.1491C16.373 19.5647 15.5596 20.0328 14.6342 20.581L7.64597 13.5925L7.24108 9.54789C7.11451 8.32631 7.40799 7.09806 8.07311 6.06567C8.82754 5.03592 9.76764 4.15614 10.8451 3.47157L10.8709 3.44577C11.0987 3.28558 11.6869 3.01594 12.7102 3.46089L10.8433 5.94375C10.7816 6.02282 10.7364 6.11337 10.7101 6.21013C10.6838 6.30689 10.6771 6.40791 10.6902 6.50731C10.7034 6.6067 10.7362 6.70247 10.7868 6.78904C10.8374 6.87561 10.9047 6.95123 10.9849 7.0115C11.065 7.07178 11.1563 7.11549 11.2535 7.14009C11.3507 7.16469 11.4518 7.16968 11.551 7.15479C11.6501 7.13989 11.7453 7.10539 11.831 7.05331C11.9166 7.00124 11.9911 6.93261 12.05 6.85146L14.9972 2.93229C15.0782 2.83529 16.1042 1.64725 17.5503 1.56983C18.5416 1.51822 19.5516 1.99966 20.5536 3.0017L24.1816 6.62987C24.2439 6.69216 24.3044 6.75268 24.372 6.80963C24.8837 7.26615 27.3024 9.71697 24.6764 12.9999C22.0272 16.3166 20.6835 17.0872 17.0982 19.1527L17.0947 19.1491Z" fill="currentColor"/>
        </g>
        </svg>`,
    basketball: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M14.0006 4.97069e-08C11.2315 -0.000233236 8.52446 0.820689 6.22192 2.35895C3.91938 3.89722 2.12471 6.08373 1.06486 8.64198C0.00500322 11.2002 -0.272423 14.0153 0.267659 16.7313C0.807742 19.4472 2.14108 21.942 4.09905 23.9001C6.05702 25.8582 8.55168 27.1918 11.2676 27.7321C13.9834 28.2724 16.7986 27.9952 19.3569 26.9356C21.9152 25.8759 24.1019 24.0814 25.6404 21.779C27.1788 19.4766 28 16.7697 28 14.0006C27.9956 10.289 26.5193 6.73056 23.8949 4.10592C21.2705 1.48128 17.7122 0.00468232 14.0006 4.97069e-08V4.97069e-08ZM25.8545 9.77447C25.6186 11.1391 24.478 12.7692 22.559 14.4559C22.0789 14.8793 21.5564 15.2957 21.0009 15.7038C20.6694 14.6063 20.278 13.5278 19.8284 12.4732C23.5898 9.85232 22.3549 6.47306 21.1707 3.66351C23.3286 5.16474 24.9656 7.30056 25.8545 9.77447V9.77447ZM19.7989 2.83079C19.9169 3.10915 20.0348 3.39105 20.1528 3.68356C21.3323 6.45065 22.5389 9.30739 19.4345 11.5862C19.3496 11.401 19.2623 11.2146 19.1738 11.0295C17.0861 6.70778 14.3273 3.35448 11.5283 1.65365C14.3383 1.09379 17.2552 1.5099 19.7966 2.83315L19.7989 2.83079ZM10.1908 2.00514C13.4273 3.53023 16.5601 7.54876 18.6301 12.1134C14.871 14.2365 11.145 12.0509 7.84714 10.1189C7.27154 9.78155 6.72898 9.46308 6.18523 9.16585C4.84768 8.43338 3.68352 8.18687 2.7128 8.42985C3.46564 6.91284 4.51547 5.56248 5.80002 4.45886C7.08457 3.35524 8.57768 2.52084 10.1908 2.00514V2.00514ZM2.13721 9.80042C2.2975 9.64093 2.48742 9.51432 2.69629 9.4277C3.44409 9.11985 4.49384 9.30975 5.7323 9.99386C6.26308 10.284 6.80093 10.5989 7.37062 10.9375C9.83223 12.38 12.5179 13.9534 15.3523 13.9534C16.6341 13.9518 17.8937 13.6186 19.0087 12.9862C19.4611 14.064 19.8517 15.1666 20.1787 16.2888C15.4608 19.4923 8.74945 21.9362 3.70475 21.2344C2.54925 19.5932 1.80382 17.699 1.53088 15.7105C1.25795 13.722 1.46546 11.697 2.13603 9.80514L2.13721 9.80042ZM4.51743 22.2641C4.87127 22.2889 5.22512 22.3007 5.57189 22.3007C8.45811 22.3007 11.3278 21.5222 13.4545 20.7544C15.9126 19.8643 18.2571 18.6873 20.4394 17.2477C20.5605 17.7353 20.6671 18.2193 20.7591 18.6997C19.7423 19.1809 18.5251 20.5975 17.0602 23.0013C16.2027 24.4073 15.4785 25.805 15.1116 26.5398C14.7448 26.5716 14.3745 26.5893 14.0006 26.5893C12.2024 26.5893 10.4252 26.2031 8.78912 25.4569C7.15308 24.7107 5.69634 23.6219 4.51743 22.2641V22.2641ZM20.9454 24.4887C19.5233 25.4352 17.9225 26.0807 16.2416 26.3853C17.5697 23.7998 19.5583 20.5468 20.9206 19.6775C21.166 21.3901 21.1919 23.0284 20.9454 24.4887V24.4887ZM21.9963 23.7102C22.1151 22.2852 22.064 20.8511 21.8442 19.4381C23.1605 19.4676 23.9083 20.5881 24.2492 21.2946C23.6065 22.1937 22.8492 23.005 21.9963 23.7078V23.7102ZM24.8342 20.3958C24.2279 19.418 23.19 18.4485 21.6861 18.4968C21.5737 17.8969 21.4365 17.2886 21.2745 16.6722C21.9551 16.1838 22.5967 15.6802 23.1829 15.1648C24.6608 13.8673 25.7165 12.5699 26.3027 11.3503C26.9689 14.4428 26.4445 17.6728 24.8342 20.3958V20.3958Z" fill="currentColor"/>
        </g>
        </svg>`,
    football: `<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <g>
        <path d="M14.0006 4.97069e-08C11.2315 -0.000233236 8.52446 0.820689 6.22192 2.35895C3.91938 3.89722 2.12471 6.08373 1.06486 8.64198C0.00500322 11.2002 -0.272423 14.0153 0.267659 16.7313C0.807742 19.4472 2.14108 21.942 4.09905 23.9001C6.05702 25.8582 8.55168 27.1918 11.2676 27.7321C13.9834 28.2724 16.7986 27.9952 19.3569 26.9356C21.9152 25.8759 24.1019 24.0814 25.6404 21.779C27.1788 19.4766 28 16.7697 28 14.0006C27.9956 10.289 26.5193 6.73056 23.8949 4.10592C21.2705 1.48128 17.7122 0.00468232 14.0006 4.97069e-08V4.97069e-08ZM24.3553 16.2239L21.4066 16.5141L18.9533 12.3859L20.3852 7.81769L23.6606 7.75871L26.2614 12.2266L24.3553 16.2239ZM17.4647 21.2403L12.3269 21.2627L10.2226 17.3916L12.8812 13.0511L18.1948 12.9497L20.5715 16.9482L17.4647 21.2403ZM5.56482 16.6061L3.33086 11.4871L5.49759 7.52753L10.1755 7.77759L12.1181 12.4956L9.49725 16.7689L5.56482 16.6061ZM23.5049 5.76065L23.3233 6.82219L20.0207 6.88235L15.5009 3.91356L15.16 1.46965C18.3914 1.7687 21.3818 3.30636 23.5049 5.76065V5.76065ZM14.1999 1.41539L14.5455 3.89233L10.2616 6.84107L5.71815 6.59455L5.50112 4.72741C7.81774 2.59509 10.852 1.41272 14.0006 1.41539H14.1999ZM1.5852 11.9412L2.49459 11.9306L4.76748 17.1381L4.56696 21.1731L3.93358 21.5435C2.91289 20.185 2.1785 18.6336 1.77484 16.9831C1.37119 15.3326 1.30667 13.6174 1.5852 11.9412V11.9412ZM4.53394 22.2854L4.99866 22.0129L9.22361 24.5205L10.061 25.9489C7.9255 25.242 6.01768 23.9772 4.53512 22.2854H4.53394ZM11.3585 26.3027L10.1188 24.1796L10.1389 24.1702L12.0756 22.2087L17.7773 22.1827L19.3826 23.8883L18.439 25.7755C16.1795 26.6267 13.723 26.8105 11.362 26.3051L11.3585 26.3027ZM19.7978 25.1645L20.5137 23.7326L23.7656 21.9268C22.6773 23.2657 21.3272 24.3682 19.7978 25.1669V25.1645ZM25.1232 19.8816L24.9639 17.1369L26.5822 13.7541C26.5822 13.8366 26.5822 13.918 26.5822 14.0006C26.585 16.0508 26.084 18.0704 25.1232 19.8816Z" fill="currentColor"/>
        </g>
        </svg>`,
    afl:`<svg fill="currentColor" width="100%" height="100%" viewBox="95 95 322 322" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <path d="M354.865,101.313c-70.823,4.577-131.776,30.699-177.322,76.244    c-45.667,45.666-71.891,107.777-76.275,178.654c1.052,0.093,2.08,0.521,2.884,1.324l48.917,48.918    c1.193,1.193,1.588,2.869,1.217,4.396c72.044-4.038,134.03-30.223,180.178-76.37c44.796-44.796,70.891-105.398,76.012-174.568    l-54.35-54.351C354.973,104.407,354.556,102.8,354.865,101.313z M362.716,140.9c1.82,1.819,1.82,4.771,0,6.59l-17.67,17.67    l17.67,17.67c1.82,1.819,1.82,4.771,0,6.59c-0.909,0.91-2.103,1.365-3.294,1.365c-1.192,0-2.386-0.455-3.295-1.365l-17.67-17.67    l-21.364,21.363l17.67,17.67c1.82,1.819,1.82,4.771,0,6.59c-0.909,0.91-2.103,1.365-3.295,1.365c-1.191,0-2.385-0.455-3.294-1.365    l-17.67-17.67l-21.363,21.363l17.67,17.67c1.82,1.819,1.82,4.77,0,6.59c-0.909,0.909-2.103,1.364-3.295,1.364    s-2.385-0.455-3.295-1.364l-17.67-17.671l-21.362,21.363l17.669,17.67c1.82,1.82,1.82,4.771,0,6.591    c-0.909,0.91-2.103,1.365-3.295,1.365s-2.385-0.455-3.294-1.365l-17.67-17.67l-21.363,21.362l17.67,17.67    c1.82,1.819,1.82,4.771,0,6.59c-0.91,0.91-2.103,1.365-3.295,1.365c-1.193,0-2.385-0.455-3.295-1.365l-17.669-17.67    l-21.363,21.364l17.67,17.67c1.82,1.819,1.82,4.77,0,6.589c-0.91,0.91-2.103,1.365-3.295,1.365s-2.385-0.455-3.295-1.365    l-17.669-17.67l-21.364,21.364l17.67,17.67c1.82,1.819,1.82,4.77,0,6.589c-0.91,0.91-2.103,1.365-3.295,1.365    c-1.193,0-2.385-0.455-3.295-1.365l-17.669-17.67l-17.67,17.67c-0.91,0.91-2.103,1.365-3.295,1.365    c-1.193,0-2.385-0.455-3.295-1.365c-1.82-1.819-1.82-4.77,0-6.589l17.67-17.67l-17.67-17.671c-1.82-1.819-1.82-4.77,0-6.589    c1.821-1.82,4.771-1.82,6.59,0l17.67,17.67l21.363-21.363l-17.67-17.671c-1.82-1.819-1.82-4.771,0-6.59    c1.821-1.82,4.771-1.819,6.59,0l17.67,17.671l21.363-21.364l-17.67-17.669c-1.82-1.82-1.82-4.771,0-6.591    c1.82-1.819,4.77-1.819,6.59,0l17.669,17.67l21.363-21.362l-17.67-17.67c-1.82-1.82-1.82-4.771,0-6.59    c1.82-1.819,4.77-1.819,6.59,0l17.67,17.67l21.362-21.363l-17.669-17.67c-1.82-1.819-1.82-4.771,0-6.59    c1.818-1.819,4.771-1.819,6.589,0l17.67,17.67l21.362-21.363l-17.669-17.67c-1.82-1.819-1.82-4.77,0-6.59    c1.818-1.819,4.771-1.819,6.59,0l17.67,17.67l21.363-21.363l-17.669-17.67c-1.82-1.819-1.82-4.771,0-6.59    c1.818-1.819,4.771-1.819,6.589,0l17.67,17.67l17.67-17.67C357.945,139.081,360.897,139.081,362.716,140.9z" id="XMLID_433_"/>
                <path d="M102.017,409.984c10.901,0.952,21.793,1.434,32.431,1.434c3.438,0,6.847-0.066,10.243-0.163    l-43.948-43.948C100.334,381.236,100.751,395.48,102.017,409.984z" id="XMLID_436_"/>
                <path d="M409.992,102.009c-10.876-0.947-21.741-1.427-32.354-1.427c-4.39,0-8.738,0.094-13.059,0.252    l46.584,46.585C411.713,132.619,411.344,117.466,409.992,102.009z" id="XMLID_437_"/>
            </g>
        </svg>`,
    lotto: `<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none">
            <path d="M14.1479 4.71993C13.7115 3.98929 12.9129 3.5 12 3.5C11.0871 3.5 10.2885 3.98929 9.85214 4.71993C9.41177 4.48155 8.93822 4.29666 8.44019 4.17396C9.10369 2.88308 10.4487 2 12 2C13.5513 2 14.8963 2.88308 15.5598 4.17396C15.0618 4.29666 14.5882 4.48155 14.1479 4.71993Z" fill="currentColor"/>
            <path d="M9.38404 7.43749C9.91377 7.25428 10.4687 7.12515 11.0424 7.05673C10.1331 5.81007 8.66115 5 7 5C4.23858 5 2 7.23858 2 10C2 11.6611 2.81007 13.1331 4.05673 14.0424C4.12515 13.4687 4.25428 12.9138 4.43749 12.384C3.85581 11.7591 3.5 10.9211 3.5 10C3.5 8.067 5.067 6.5 7 6.5C7.9211 6.5 8.7591 6.85581 9.38404 7.43749Z" fill="currentColor"/>
            <path d="M19.9433 14.0424C21.1899 13.1331 22 11.6611 22 10C22 7.23858 19.7614 5 17 5C15.3389 5 13.8669 5.81007 12.9576 7.05673C13.5313 7.12515 14.0862 7.25428 14.616 7.43749C15.2409 6.85581 16.0789 6.5 17 6.5C18.933 6.5 20.5 8.067 20.5 10C20.5 10.9211 20.1442 11.7591 19.5625 12.384C19.7457 12.9138 19.8748 13.4687 19.9433 14.0424Z" fill="currentColor"/>
            <path d="M9.5 13.25C9.5 12.8358 9.83579 12.5 10.25 12.5H14.5C14.8125 12.5 15.0922 12.6937 15.2021 12.9862C15.3118 13.2782 15.2293 13.6076 14.995 13.8134L14.9942 13.8142L14.982 13.8252C14.9708 13.8353 14.9527 13.852 14.9285 13.8749C14.8801 13.9208 14.8073 13.9918 14.7162 14.0864C14.5338 14.276 14.28 14.5586 14.0034 14.9226C13.4473 15.6542 12.8157 16.693 12.4736 17.9473C12.3646 18.347 11.9523 18.5826 11.5527 18.4736C11.153 18.3646 10.9174 17.9523 11.0264 17.5527C11.4343 16.057 12.1777 14.8458 12.8091 14.0149L12.8205 14H10.25C9.83579 14 9.5 13.6642 9.5 13.25Z" fill="currentColor"/>
            <path d="M12 22C15.866 22 19 18.866 19 15C19 11.134 15.866 8 12 8C8.13401 8 5 11.134 5 15C5 18.866 8.13401 22 12 22ZM12 20.5C8.96243 20.5 6.5 18.0376 6.5 15C6.5 11.9624 8.96243 9.5 12 9.5C15.0376 9.5 17.5 11.9624 17.5 15C17.5 18.0376 15.0376 20.5 12 20.5Z" fill="currentColor"/>
        </svg>`,

}

export const SPORTS = [
        {
            title: 'Horse Racing',
            titleSlider: 'Horse Races',
            code: 'H,h,o',
            antePostCode: "a",
            type: 'race',
            // url: `${base_url_v0}events/sports-api.asp?sportcode=H,h`,
            
            url: `${geoff_api}GetSportApiData?sportcode=H,h,o`,
            // antePostUrl:`${base_url}GetAntepostEvents/a`,
            img: require('../assets/sports-bar/hourse.svg'),
            svg: SPORTSVG.hourse,
            isSortable: true,
            bogInfoPath: 'bog',
            isCarouselRegion: true,
            showResultsFeed: true,
            showVideoStream: true,
            subcategories: [
                {
                    title: 'All',
                    shortTitle: 'ALL',
                    code: 'H,h,o',
                    antePostCode: "a",
                    // url: `${base_url_v0}events/sports-api.asp?sportcode=H,h`,
                    url: `${geoff_api}GetSportApiData?sportcode=H,h,o`,
                    type: 'race',
                    carouselRegionId: 1
                },
                {
                    title: 'UK/IR',
                    shortTitle: 'UK/IR',
                    code: 'H,h',
                    antePostCode: "a",
                    // url: `${base_url_v0}events/sports-api.asp?sportcode=H,h`,
                    url: `${geoff_api}GetSportApiData?sportcode=H,h`,
                    type: 'race',
                    carouselRegionId: 2
                },
                // {
                //     title: 'Irish',
                //     code: 'H',
                //     antePostCode: "a",
                //     // url: base_url_v0 + "events/sports-api.asp?sportcode=H",
                //     url: `${geoff_api}GetSportApiData?sportcode=H`,
                //     svg: SPORTSVG.hourse,
                //     img: require('../assets/sports-bar/hourse.svg'),
                //     type: 'race'
                // },
                {
                    title: 'International',
                    shortTitle: 'INT',
                    code: 'o',
                    antePostCode: "a",
                    // url: `${base_url_v0}events/sports-api.asp?sportcode=o`,
                    url: `${geoff_api}GetSportApiData?sportcode=o`,
                    svg: SPORTSVG.hourse,
                    img: require('../assets/sports-bar/hourse.svg'),
                    type: 'race',
                    carouselRegionId: 3
                },
            ]
        },
        {
            title: 'Greyhounds',
            code: 'g,q',
            antePostCode: 'q',
            // antePostUrl: `${base_url}GetAntepostEvents/q`,
            type: 'race',
            // url: `${base_url_v0}events/sports-api.asp?sportcode=g,q`,
            url: `${geoff_api}GetSportApiData?sportcode=g,q`,
            svg: SPORTSVG.greyhounds,
            img: require('../assets/sports-bar/greyhounds.svg'),
            bogInfoPath: 'dogs',
            showResultsFeed: true,
            showVideoStream: true
        },
        {
            title: 'Virtual Horse',
            code: 'vh',
            antePostCode: null, //'',
            type: 'race',
            // url: `${base_url_v0}events/sports-api.asp?sportcode=vh`,
            url: `${geoff_api}GetSportApiData?sportcode=vh`,
            svg: SPORTSVG.hourse,
            img: require('../assets/sports-bar/hourse.svg'),
            isSortable: true,
            showResultsFeed: true,
            showVideoStream: true
        },
        {
            title: 'Virtual Greyhounds',
            code: '$',
            antePostCode: null, //'$',
            type: 'race',
            // url: `${base_url_v0}events/sports-api.asp?sportcode=$`,
            url: `${geoff_api}GetSportApiData?sportcode=$`,
            svg: SPORTSVG.greyhounds,
            img: require('../assets/sports-bar/greyhounds.svg'),
            showResultsFeed: true,
            showVideoStream: true
        },
        {
            title: 'Lotto',
            code: 'L',
            antePostCode: null,
            type: 'lotto',
            url: `${geoff_api}GetSportApiData?sportcode=L`,
            svg: SPORTSVG.lotto,
            isNew: true
        },
        {
            title: 'Football',
            code: 'f',
            type: 'competition',
            url: `${geoff_api}GetEventsDetailFullcard/f?fullcard=1`,
            // antePostUrl:`${base_url}GetAntepostEvents/s`,
            antePostCode: 's',
            svg: SPORTSVG.football,
            img: require('../assets/sports-bar/football.svg'),
            bg: require(isMobile?'../assets/sports/football-bg.jpg':'../assets/sports/football-bg-l.jpg'),
            tabs: [
                {
                    label: "Popular",
                    values:[
                        "Full Time Result",
                        "Double Chance",
                        "Goals over/under",
                        "Both Teams to score",
                        "Result and Both Teams to Score",
                        "To Qualify",
                        "Method of Victory",
                        "Half time Full time",
                        "Handicap Betting",
                        "Draw no Bet",
                        "Goals Over Under",
                        "Result Both Teams To Score",
                        "Alternative Handicaps",
                        "Match Handicap",
                        "Method of Qualification"
                    ]
                },
                {
                    label: "Goals",
                    values:[
                        "Full Time Score",
                        "Goals over/under",
                        "Alternative Total Goals",
                        "Result & Total Goals",
                        "Team Total Goals",
                        "First Half Goals",
                        "Result Total Goals"
                    ]
                },
                {
                    label: "Player",
                    values: [
                        "Player To Be Booked",
                        "First Goalscorer",
                        "Last Goalscorer",
                        "Anytime Goalscorer",
                    ]
                },
                {
                    label: "Cards", 
                    values: [
                        "Player To Be Booked",
                        "Cards Over/Under",
                        "Both Teams To Receive A Card",
                        "Number Of Cards In Match",
                        "Card Handicap",
                        "Both Teams to Receive 2+ Cards",
                    ]
                },
                {
                    label: "Corners",
                    values: [
                        "Corners",
                        "Total Corners",
                        "First Half Corners",
                        "Corner Match Bet",
                        "Corner Handicap",
                        "Corners 2-Way"
                    ]
                }

            ],
            // addMarkets: ["Double Chance", "Goals Over Under", "Both Teams To Score", "Draw No Bet"]
            // addMarkets: ["Goals Over Under", "Both Teams To Score", "Draw No Bet"]
        },
        {
            title: 'Tennis',
            url: geoff_api + "GetEventsDetailFullcard/N?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/t`,
            code: 'N',
            antePostCode: 't',
            type: 'competition',
            svg: SPORTSVG.tennis,
            img: require('../assets/sports-bar/tennis.svg'),
            bg: require(isMobile?'../assets/sports/tennis-bg.jpg':'../assets/sports/tennis-bg-l.jpg'),
            // addMarkets: ['Match Handicap Games', 'Total Games 2 Way']

        },
        {
            title: 'Baseball',
            code: 'e',
            antePostCode: 'n',
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/e?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/n`,
            svg: SPORTSVG.baseball,
            img: require('../assets/sports-bar/baseball.svg'),
            bg: require(isMobile?'../assets/sports/baseball-bg.jpg':'../assets/sports/baseball-bg-l.jpg'),
            // addMarkets: ['Run Line', 'Total Runs']
        },
        {
            title: 'Basketball',
            code: 'E',
            antePostCode: 'k',
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/E?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/k`,
            svg: SPORTSVG.basketball,
            img: require('../assets/sports-bar/basketball.svg'),
            bg: require(isMobile?'../assets/sports/bascketball-bg.jpg':'../assets/sports/bascketball-bg-l.jpg'),
            // addMarkets: ['Money Line', 'Over/Under'] // 'Point Spread',
        },
        {
            title: 'Golf',
            code: 'm',
            antePostCode: 'G',
            type: 'competition',
            url: `${geoff_api}GetEventsDetailFullcard/m?fullcard=1`,
            // antePostUrl: `${base_url}GetAntepostEvents/G`,
            svg: SPORTSVG.golf,
            img: require('../assets/sports-bar/golf.svg'),
            bg: require(isMobile?'../assets/sports/golf-bg.jpg':'../assets/sports/golf-bg-l.jpg'),
        },
        {
            title: 'Cricket',
            code: 'C',
            antePostCode: 'K',
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/C?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/K`,
            svg: SPORTSVG.cricket,
            img: require('../assets/sports-bar/cricket.svg'),
            bg: require(isMobile?'../assets/sports/cricket-bg.jpg':'../assets/sports/cricket-bg-l.jpg'),
        },

        {
            title: 'Rugby League',
            code: 'l',
            antePostCode: 'r',
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/l?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/r`,
            svg: SPORTSVG.rugby,
            img: require('../assets/sports-bar/rugby.svg'),
            bg: require(isMobile?'../assets/sports/rugby-bg.jpg':'../assets/sports/rugby-bg-l.jpg'),
            // addMarkets: ['Total Points (2-Way)', 'Match Result (3-Way)']
        },
        {
            title: 'Rugby Union',
            code: 'v',
            antePostCode: 'R',
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/v?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/R`,
            svg: SPORTSVG.rugby,
            img: require('../assets/sports-bar/rugby.svg'),
            bg: require(isMobile?'../assets/sports/rugby-bg.jpg':'../assets/sports/rugby-bg-l.jpg'),
            // addMarkets: ['Total Points (2-Way)', 'Match Result (3-Way)']
        },
        {
            title: 'American Football',
            code: 'F',
            antePostCode: 'A',
            type: 'competition',
            url:`${geoff_api}GetEventsDetailFullcard/F?fullcard=1`,
            // antePostUrl: `${base_url}GetAntepostEvents/A`,
            svg: SPORTSVG.nfl,
            img: require('../assets/sports-bar/nfl.svg'),
            bg: require(isMobile?'../assets/sports/nfl-bg.jpg':'../assets/sports/nfl-bg-l.jpg'),
            // addMarkets: ['Total Points', 'Money Line'] //'Point Spread'
        },
        {
            title: 'Aussie Rules',
            code: 'u',
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/u?fullcard=1",
            svg: SPORTSVG.afl,
            img: require('../assets/sports-bar/rugby.svg'),
            bg: require('../assets/sports/afl-bg-l.jpg'),
        },
        {
            title: 'Ice Hockey',
            code: 'y',
            antePostCode: 'Y',
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/y?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/Y`,
            svg: SPORTSVG.hokey,
            img: require('../assets/sports-bar/hokey.svg'),
            bg: require(isMobile?'../assets/sports/hockey-bg.jpg':'../assets/sports/hockey-bg-l.jpg'),
        },
        {
            title: 'Boxing',
            code: 'b',
            antePostCode: null,
            type: 'competition',
            url:geoff_api + "GetEventsDetailFullcard/b?fullcard=1",
            svg: SPORTSVG.boxing,
            img: require('../assets/sports-bar/boxing.svg'),
            bg: require(isMobile?'../assets/sports/box-bg.jpg':'../assets/sports/box-bg-l.jpg'),
        },
        {
            title: 'UFC | MMA',
            code: 'b',
            antePostCode: null,
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/b?fullcard=1",
            svg: SPORTSVG.ufc,
            img: require('../assets/sports-bar/ufc.svg'),
            bg: require(isMobile?'../assets/sports/ufc-bg.jpg':'../assets/sports/ufc-bg-l.jpg'),
            meta: {
                pageTitle: 'UFC / MMA',
            }
        },
        {
            title: 'Darts',
            code: 'I',
            antePostCode: 'D',
            type: 'competition',
            url:geoff_api + "GetEventsDetailFullcard/I?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/D`,
            svg: SPORTSVG.darts,
            img: require('../assets/sports-bar/darts.svg'),
            bg: require(isMobile?'../assets/sports/darts-bg.jpg':'../assets/sports/darts-bg-l.jpg'),
        },
        {
            title: 'Snooker',
            code: 'j',
            antePostCode: 'S',
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/j?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/S`,
            svg: SPORTSVG.snooker,
            img: require('../assets/sports-bar/snooker.svg'),
            bg: require(isMobile?'../assets/sports/snooker-bg.jpg':'../assets/sports/snooker-bg-l.jpg'),
        },
        {
            title: 'Cycling',
            code: null,
            antePostCode: 'c',
            url: null,
            type: 'race',
            // antePostUrl: `${base_url}GetAntepostEvents/c`,
            svg: SPORTSVG.сycling,
            img: require('../assets/sports-bar/сycling.svg'),
        },
        {
            title: 'GAA',
            code: 'J',
            antePostCode: 'd', //'D',
            type: 'competition',
            url: geoff_api + "GetEventsDetailFullcard/J?fullcard=1",
            // antePostUrl: `${base_url}GetAntepostEvents/d`,
            svg: SPORTSVG.gaa,
            img: require('../assets/sports-bar/gaa.svg'),
            bg: require(isMobile?'../assets/sports/gaa-bg.jpg':'../assets/sports/gaa-bg-l.jpg'),
        },
        {
            title: 'Motor Racing',
            code: null, // ???
            antePostCode: 'M', 
            url: null,
            type: 'race',
            // antePostUrl: `${base_url}GetAntepostEvents/M`,
            svg: SPORTSVG.motor,
            img: require('../assets/sports-bar/motor.svg'),
        },
        {
            title: 'Special',
            code: null,
            antePostCode: 'z',
            url: null,
            type: 'competition',
            // antePostUrl: `${base_url}GetAntepostEvents/z`,
            svg: SPORTSVG.special,
            img: require('../assets/sports-bar/special.svg'),
            meta: {
                pageTitle: 'Specials'
            }
        },
    ]

export function getLocationData(){
    return new Promise((resolve, reject)=>{
        axios.get('https://api.ipgeolocation.io/ipgeo?apiKey=d3bd1d54fe874ce2907520ca38b8523a')
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}
export function geocoding(lat, lng){
    return new Promise((resolve, reject)=>{
        axios.get(`https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lng}&language=en&key=75d0d25c29844e93bb8be95f008c8e5c`)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}
/*
// not used
 export function GetSportInfo(sportCode) {
     let sportDetail = [];
     _.find(Sports, function (sport) {
         if (sport.SportCode == sportCode) {
             sportDetail = sport;
         } else {
             if (
                 typeof sport != "undefined" &&
                 typeof sport.SubItems != "undefined" &&
                 sport.SubItems.length > 0
             ) {
                 _.find(sport.SubItems, function (subItem) {
                     // subItem.SportCode == sportCode;
                     if (subItem.SportCode == sportCode) {
                         sportDetail = subItem;
                     }
                 });
             }
         }
     });
     return sportDetail;
 }
 */

export function ParseEventData(data) {
    if (data.Races) {
        //console.log("Races");
        data.Races.forEach((race) => {
            let pInfo = race.Price1 || race.Price2
            if (!pInfo) return
            let p1Sets = pInfo.split("&");
            p1Sets.forEach((element) => {
                var keyVals = element.split("=");
                race[keyVals[0]] = keyVals[1];
            });
        });
        //console.log(data, "parserdata");
    } else if (data.Events) {
        data.Events.forEach((race) => {
            let pInfo = race.PriceLink1 || race.PriceLink2
            if (!pInfo) return
            let p1Sets = pInfo.split("&");
            p1Sets.forEach((element) => {
                var keyVals = element.split("=");
                race[keyVals[0]] = keyVals[1];
            });
        });
        data.Races = data.Events
    } else if (data.events) {
        //console.log("Events");
        data.events.forEach((race) => {
            let pInfo = race.priceLink1 || race.priceLink2
            if (!pInfo) return
            let p1Sets = pInfo.split("&");
            p1Sets.forEach((element) => {
                var keyVals = element.split("=");
                race[keyVals[0]] = keyVals[1];
            });
        });
        data.Races = (data.Events ) // TODO || data.events ???
        //console.log(data, "parserdata");
    } else if (data.Meetings) {
        //console.log("MeetingLink");
        data.Meetings.forEach((race) => {
            if (!(typeof race.MeetingLink == "undefined")) {
                var pInfo = race.MeetingLink;
                if (
                    pInfo.trim().length <= 0 &&
                    !(typeof race.MeetingLink == "undefined") &&
                    race.MeetingLink.length > 0
                )
                    pInfo = race.MeetingLink;
                var p1Sets = pInfo.split("&");
                p1Sets.forEach((element) => {
                    var keyVals = element.split("=");
                    race[keyVals[0]] = keyVals[1];
                });
            }
        });
        data.Races = data.Meetings
    }
    if (data.Races){
        const racesWithPrice = data.Races.filter(r=>r.price)
        if (racesWithPrice.length) data.Races = racesWithPrice

    }
    return data;
}

export function ParseEventArrayData(data) {
    data.forEach((event) => {
        if (event.Meetings) {
            event.Meetings.forEach((race) => {
                if (!(typeof race.MeetingLink == "undefined")) {
                    var pInfo = race.MeetingLink;
                    if (
                        pInfo.trim().length <= 0 &&
                        !(typeof race.MeetingLink == "undefined") &&
                        race.MeetingLink.length > 0
                    )
                        pInfo = race.MeetingLink;
                    var p1Sets = pInfo.split("&");
                    p1Sets.forEach((element) => {
                        var keyVals = element.split("=");
                        race[keyVals[0]] = keyVals[1];
                    });
                }
            });
        } else if (event.Events != null) {
            event.Events.forEach((race) => {
                if (
                    !(typeof race.PriceLink1 == "undefined") &&
                    race.PriceLink1 != null
                ) {
                    var pInfo = race.PriceLink1;
                    if (
                        pInfo.trim().length <= 0 &&
                        !(typeof race.PriceLink1 == "undefined") &&
                        race.PriceLink2.length > 0
                    )
                        pInfo = race.PriceLink2;
                    var p1Sets = pInfo.split("&");
                    p1Sets.forEach((element) => {
                        var keyVals = element.split("=");
                        race[keyVals[0]] = keyVals[1];
                    });
                }
            });
        }
    });
    return data;
}

export function AllowedCountries(platform){
    // const URL = `https://api.geoff-banks.com/Geoff/GetCountries/${platform==='ios'?'iphone':'android'}?c=${Math.random()}`
    
    // GET https://dev-globalapi.geoffbanks.bet/api/cms/get-countries/{platform} (android/iphone)
    // const directus_csm = `${betslip_prod_api}/api/cms/`;

    const URL = `${directus_csm}get-countries/${platform==='ios'?'iphone':'android'}?c=${Math.random()}`
        return new Promise((resolve, reject) => {
            axios.get(URL)
                .then(res=>resolve(res.data))
                .catch(error=>reject(error))
        })
}


// BLOG
export function getBlog(page = null, itemsCount = null){
    return new Promise((resolve, reject)=>{
        let url = `${directus_csm}blog-collection`
        let isParam = false
        if(page) {
            url = `${url}?page=${page}`
            isParam = true
        }
        if(itemsCount) {
            url = `${url}${isParam ? '&': '?'}limit=${itemsCount}`
        }
        axios.get(url)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}
export function getBlogPage(pageName){
    return new Promise((resolve, reject)=>{
        axios.get(`${directus_csm}blog-article/${pageName}`)
            .then(res=>resolve(res.data?.data))
            .catch(error=>reject(error))
    })
}

// Account & settings requests
export function getPromotions(){
    return new Promise((resolve, reject)=>{
        axios.get(`${directus_csm}get-promotions?site=${siteId}`)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function getPageData(pageName) {
    return new Promise((resolve, reject)=>{
    axios.get(`${directus_csm}get-page?url=${pageName}&site=${siteId}`)
        .then(res=>resolve(res.data))
        .catch(error=>reject(error))
    })
}

export function getSettings() {
    return new Promise((resolve, reject)=>{
        let URL = `${directus_csm}get-settings?appVersion=${process.env.VUE_APP_VERSION}`
        if (store.state.platform === 'ios') {
            URL = URL + `&platform=1`
        }
        if (store.state.platform === 'android') {
            URL = URL + `&platform=0`
        }
        axios.get(URL)
            .then(res =>resolve(res.data))
            .catch(error=>reject(error))
    })
}

/*
export function login(username, password, callback, errorCallback) {
    axios.post(
        `${base_url}Login`,
        `username=${username}&password=${password}`,
        {headers: { Accept: "application/json", "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"}}
    )
        .then((response)=>callback(response.data))
        .catch((error)=>errorCallback(error))
}
*/

export function login(username, password, callback, errorCallback) {
    axios.post(
        `${betslip_prod_api}/api/user/login`,
        {
            Login: username, 
            Password: password 
        },
    )
        .then((response)=>callback(response.data))
        .catch((error)=>errorCallback(error))
}

/*
export function changePassword(username, oldPassword, newPassword, confirmPassword) {
  return new Promise((resolve, reject)=>{
      axios.post(
      `${base_url}UpdatePassword?username=${username}&oldpassword=${oldPassword}`+
          `&newpassword=${newPassword}&confirmnewpassword=${confirmPassword}`,
      {},
      {
          headers: {
              Accept: "application/json",
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          }
      }
      )
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
  })
}
*/

/*
POST https://geoffbanks-api.azurewebsites.net/api/user/update-password

JsonBody:
{
    "Login": "es20", 
    "OldPassword": "testt" ,
    "NewPassword": "testt1" ,
    "ConfirmNewPassword": "testt1" 
}

Responce: true/false
*/
export function changePassword(username, oldPassword, newPassword, confirmPassword) {
    return new Promise((resolve, reject)=>{
        axios.post(
        `${betslip_prod_api}/api/user/update-password`,
        {
            Login: username, 
            OldPassword: oldPassword,
            NewPassword: newPassword,
            ConfirmNewPassword: confirmPassword 
        },
        // {
        //     headers: {
        //         Accept: "application/json",
        //         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        //     }
        // }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

/*
export function getUserInfo(userCreds){
    return new Promise((resolve, reject)=>{
        axios.get(`${base_url}GetUserInfo/${userCreds.username}/${userCreds.password}`)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}
*/
export function getUserInfo(userCreds){
    return new Promise((resolve, reject)=>{
        // axios.get(`${base_url}GetUserInfo/${userCreds.username}/${userCreds.password}`)
        // `${betslip_prod_api}/api/user/user-info`,
        axios.post(
            `${betslip_prod_api}/api/user/user-info-v1`,
            {
                Login: userCreds.username, 
                Password: userCreds.password 
            },
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            })
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function getUserPreferences(userName) {
  return new Promise((resolve, reject)=>{
    axios.get(`${items_url}user_preferences?fields=*.*&filter[userid][eq]=${userName}`)
        .then(res=>resolve(res.data))
        .catch(error=>reject(error))
    })

}

export function getIsShowTermsModal() {
    return new Promise((resolve, reject)=>{
        axios.get(
            `${betslip_prod_api}/api/user/show-terms-and-conditions-modal`,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
    })
  
}

export function postTermsAccepted(){
    return new Promise((resolve, reject)=>{
        axios.post(
            `${betslip_prod_api}/api/user/accept-terms-and-conditions`,
            null,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function getIsShowMarketingModal() {
    return new Promise((resolve, reject)=>{
        axios.get(
            `${betslip_prod_api}/api/user/show-marketing-modal`,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
    })
  
}

export function postMarketingModal(model){
    return new Promise((resolve, reject)=>{
        axios.post(
            `${betslip_prod_api}/api/user/marketing-modal-submit`,
            model,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function getUserPreferencesAzure() {
    return new Promise((resolve, reject)=>{
        axios.get(
            `${betslip_prod_api}/api/user/get-user-preferences`,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function setUserPreferencesAzure(model) {
    return new Promise((resolve, reject)=>{
        axios.post(
            `${betslip_prod_api}/api/user/update-user-preferences`,
            model,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

// POST Compliance Survey
// model
// {
//     "BettingLevel": false, // Are you comfortable with your betting levels?
//     "ResponsibleGamblingTool": true, // Have you considered using any of the Responsible Gambling tools available on our website?
//     "StressRelatedIssue": false // Does your gambling cause you stress related issues?
// }
export function postComplianceForm(model) {
    return new Promise((resolve, reject)=>{
        axios.post(
            `${betslip_prod_api}/api/forms/ComplianceQuestionaire`,
            model,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function postResponsibleGamblingCheck(model) {
    return new Promise((resolve, reject)=>{
        axios.post(
            `${betslip_prod_api}/api/forms/SaferGambling`,
            model,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function postInsolvency() {
    return new Promise((resolve, reject)=>{
        axios.post(
            `${betslip_prod_api}/api/forms/insolvency-notification`,
            {},
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            })
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}


// POST responsible gambling
// model
// {
//     "RestrictionType": 2, // RestrictionType.AccountDeactivation = 0; RestrictionType.TakeABreak = 1 RestrictionType.SelfExclusion = 2}
//     "Period": 7, // Period.OneDay = 0,
                    // Period.OneWeek = 1,
                    // Period.TwoWeeks = 2,
                    // Period.FourWeeks = 3,
                    // Period.SixWeeks = 4,
                    // Period.SixMonths = 5,
                    // Period.OneYear = 6,
                    // Period.TwoYears = 7,
                    // Period.ThreeYears = 8,
                    // Period.FourYears = 9,
                    // Period.FiveYears = 10
//     "ReasonForClosure": "Test" // optional, 200 char max
// }
// answer 
// {
//     "answer": true
// }
export function postResponsibleGamblingForm(model) {
    return new Promise((resolve, reject)=>{
        axios.post(
            `${betslip_prod_api}/api/forms/ResponsibleGambling`,
            model,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

// POST Account Verification

// account Verification
export function postAccountVerificationForm(model) {
    return new Promise((resolve, reject)=>{
        axios.post(`${betslip_prod_api}/api/forms/AccountVerification `, model)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

// account recativation
export function postAccountReactivation(model) {
    return new Promise((resolve, reject)=>{
        axios.post(`${betslip_prod_api}/api/forms/AccountReactivation `, model)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

// reset password
export function postResetPassword(model) {
    return new Promise((resolve, reject)=>{
        axios.post(`${betslip_prod_api}/api/forms/lost-password `, model)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}


export function getUserActivity(rangeType) {
    return new Promise((resolve, reject)=>{
        axios.get(
            `${betslip_prod_api}/api/user/get-user-activity/${rangeType}`,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function getDepositLimit() {
    return new Promise((resolve, reject)=>{
        axios.get(
            `${betslip_prod_api}/api/user/get-deposit-limit`,
            { 
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
                }
            }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function getUserDetailFromDirectus() {
    // console.log('DEBUG getUserDetailFromDirectus AUTH_TOKEN_KEY, username', localStorage.getItem(AUTH_TOKEN_KEY), username)
    // https://dev-globalapi.geoffbanks.bet/api/cms/get-user-detail
    // const url = items_url + "user_detail?access_token=" + access_token + "&filter[username]=" + username
    const url = `${directus_csm}get-user-detail`;

    return new Promise((resolve, reject)=>{
        axios.get(url, { headers: {
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }
        }).then(res=>resolve(res)).catch(error=>reject(error))
    })
}

export function updateUserDetails(data) {
//   let url = items_url + "user_detail/" + data.id + "?access_token=" + access_token;
  let url = `${directus_csm}update-user-detail`;
  return new Promise((resolve, reject)=>{
      axios.patch(url,data,
        { headers: {
            Accept: "application/json","Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
        }})
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
  })
}

export function createUserDetails(data) {
//   const URL = items_url + "user_detail?access_token=" + access_token;
  let URL = `${directus_csm}add-user-detail`;
  return new Promise((resolve, reject)=>{
      axios.post(URL,data,
        { headers: {
            Accept: "application/json","Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}` // TODO: check
        }})
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
  })
}

export function updateUserDetailToNewDB(data) {
  const userCreds = JSON.parse(localStorage.getItem('userCreds'))
    return new Promise((resolve, reject)=>{
        axios.post(
            `${base_url}UpdateUser?userId=${userCreds.username}&password=${userCreds.password}`,
            data
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function register(data, referral, ip, sessionId) {
    // const URL = `${betslip_prod_api}/api/user/registration?Referral=${referral}&UserIP=${ip}`
    const URL = `${betslip_prod_api}/api/user/confirm-registration?Referral=${referral}&UserIP=${ip}&SessionId=${sessionId}&api-version=0.2`
    return new Promise((resolve, reject)=>{
        axios.post(URL, 
            data,
            {headers:{'content-type':'multipart/form-data', 'accept': '*/*'}}
        )
            .then(res=>resolve(res.data))
            .catch(error=>{
                reject(error)
            })
        })
}

export function getCurrenciesRegister() {
    const URL = `${betslip_prod_api}/api/currency/get-payment-currencies`
        return new Promise((resolve, reject) => {
            axios.get(URL)
                .then(res=>{
                    resolve(res.data)
                })
                .catch(error=>reject(error))
        })
}

   

export function ipifyGetIp() {
    const URL = `https://api.ipify.org?format=json`
    return new Promise((resolve, reject)=>{
        axios.get(URL)
            .then(res=>resolve(res.data))
            .catch(error=>{
                reject(error)
            })
        })
}

//
// POST https://globalapi.geoffbanks.bet/api/user/send-email-code
// json body
// {
// "id": "662a35ea9b4ddb268b9f6332",
// "email": "test@gmail.com"
export function sendEmailCode(email, id = null) {
    const URL = `${betslip_prod_api}/api/user/send-email-code`
    return new Promise((resolve, reject)=>{
        axios.post(URL, 
            {
                email: email,
                id: id
            },
        )
            .then(res=>resolve(res.data))
            .catch(error=>{
                reject(error)
            })
        })
}



// POST https://globalapi.geoffbanks.bet/api/user/email-code-validation
// json body
// {
//     "id": "662a35ea9b4ddb268b9f6332", 
//     "email": "test@gmail.com",
//     "code": 451468
// }
export function validateEmailCode(model) {
    const URL = `${betslip_prod_api}/api/user/email-code-validation`
    return new Promise((resolve, reject)=>{
        axios.post(URL, model) 
            .then(res=>resolve(res.data))
            .catch(error=>{
                reject(error)
            })
        })
}


// NOT USED (email changing is resticted) - remove or possibly update
export function checkDuplicateEmail(email) {
  const username = JSON.parse(localStorage.getItem('userCreds')).username
  const url = `${items_url}user_detail?filter[emailaddress]=${email}&filter[username][neq]=${username}`;
  return new Promise((resolve, reject)=>{
      axios.get(url)
          .then(res=>{
              console.log(res)
              resolve(res.data.data.length)
          })
          .catch(error=>reject(error))
  })
}

export function getUserDetailsByCustRef(custRef){
    return new Promise((resolve, reject)=>{
        axios.get(`${items_url}user_profiles?filter[customer_id][eq]=${custRef}`)
            .then(res => resolve(res.data))
            .catch(error=>reject(error))

    })
}


// NOT USED: remove?
export function getBetSlipHistory(username, start_date, end_date, callback) {
    axios.get(`${items_url}bet_slip_history?filter[customer_id][eq]=${username}&filter[created_on][between]=${start_date},${end_date}`)
        .then(res => callback(res.data))
}

// Events
export function getNextRaces(sportCode="H,h,o"){
    return new Promise((resolve, reject)=>{
        axios.get(`${geoff_api}NewLive?sportcode=${sportCode}`,
            {timeout: 15000})
            .then(response=>{
                resolve (response.data)
            })
            .catch(error=>reject(error))
    })
}

export function getLiveEvents(){
    const URL = `${items_url}in_play_events_local`
    return new Promise((resolve, reject)=>{
        axios.get(URL)
            .then(response=>{
                return resolve(response.data)
            })
            .catch(error=>reject(error))
    })
}

/*
// BACKUP: old version - redo, only for races
export function getEvents(sportCode) {
    const sport = GetSportInfo(sportCode);
    let url = sport.URL;
    // if (Cache.Exists(key)) {
    //     callback(JSON.parse(Cache.Get(key)));
    // } else {
    let isRace = ['H,h', 'vh', 'g,q', '$', 'o', 'H'].some( el => el === sportCode)
    // if (isRace) {
    //     console.log('DEBUG getEvents', url)
    // }
    // let isRace = ['H,h', 'vh', 'g,q', '$'].some( el => el === sportCode)
    let enableProxy = store.state.settings.enable_cache_apiproxy

    /// old
    if(enableProxy){
        // url = ApiProxy.Get + encodeURI(url);
        if(isRace) {
            url = ApiProxy.Get + encodeURI(url);
        }
        else {
            url = `${geoff_api}GetCachedEventsDetailFullcard/${sportCode}?fullcard=1`
        }
    }
    return new Promise((resolve, reject)=>{
        axios(url)
            .then(function (response) {
                let res = response.data
                if(enableProxy){
                    if (isRace) {
                        res = response.data.Data
                    }
                    else  {
                        res = response.data.data // casediff
                    }
                }
                // Cache.Set(key, JSON.stringify(res));
                resolve(res);
            })
            .catch(error=>reject(error))
    })

    //// new
    // if(enableProxy && !isRace){
    //         url = `${geoff_api}GetCachedEventsDetail/${sportCode}?fullcard=1`
    // }
    // return new Promise((resolve, reject)=>{
    //     axios(url)
    //         .then(function (response) {
    //             let res = response.data
    //             if(enableProxy && !isRace){
    //                     res = response.data.data // casediff
    //             }
    //             // Cache.Set(key, JSON.stringify(res));
    //             resolve(res);
    //         })
    //         .catch(error=>reject(error))
    // })
}
*/


export function GetSportByCode(sportCode) {
    let sportDetail = [];
    _.find(SPORTS, function (sport) {
        if (sport.code == sportCode) {
            sportDetail = sport;
        } else {
            if (
                typeof sport != "undefined" &&
                typeof sport.subcategories != "undefined" &&
                sport.subcategories.length > 0
            ) {
                _.find(sport.subcategories, function (subItem) {
                    // subItem.SportCode == sportCode;
                    if (subItem.code == sportCode) {
                        sportDetail = subItem;
                    }
                });
            }
        }
    });
    return sportDetail;
}

// replace .url in races
export function getRaceEvents (sportCode) {
    let url = `${geoff_api}GetSportData?sportcode=${sportCode}`

    // horse racing has different endpoint for different grouping (by UK/IR/International)
    if (sportCode.split(',').every(el => ['H','h','o'].includes(el))) {
        url = `${geoff_api}RacingSportByLocation?sportcode=${sportCode}`
    }
    
    return new Promise((resolve, reject)=>{
        axios(url)
            .then(function (response) {
                resolve(response?.data);
            })
            .catch(error=>reject(error))
    })
}

export function getAntepostEvents(sportCode) {
    const url = `${geoff_api}GetAntepostEvents/${sportCode}`
    return new Promise((resolve, reject)=>{
        axios(url)
            .then(function (response) {
                resolve(response);
            })
            .catch(error=>reject(error))
    })
}
/*
// backup
export function getEvents(sportCode) {
    const sport = GetSportByCode(sportCode)

    let enableProxy = store.state.settings.enable_cache_apiproxy
    const isRace = sport.type === 'race'
    let url = ''
    // different Urls for 
    if (isRace) {
        url = `${base_url_v0}events/sports-api.asp?sportcode=${sportCode}`
        if (enableProxy) {
            url = ApiProxy.Get + encodeURI(url);
        }
    }
    else {
        url = `${geoff_api}GetEventsDetailInfo/${sport.code}`
    }

    return new Promise((resolve, reject)=>{
        axios(url)
            .then(function (response) {
                let res = response.data
                if(enableProxy && isRace){
                    res = response.data.Data
                }
                // Cache.Set(key, JSON.stringify(res));
                resolve(res);
            })
            .catch(error=>reject(error))
    })
}
*/
// for competionis only 
// use getRaceEvents for races
export function getEvents(sportCode, fullcard = true) {
    const sport = GetSportByCode(sportCode)
    const url = `${geoff_api}GetEventsDetailInfo/${sport.code}?v=1${fullcard? '': '&fullcard=0'}`
    return new Promise((resolve, reject)=>{
        axios(url)
            .then(response => resolve(response.data))
            .catch(error=>reject(error))
    })
}

// new endpoint
export function getSingleEvent(ef, eg, ev, callback) {
    const url = `${geoff_api}GetSingleEvent?ef=${ef}&eg=${eg}&e=${ev}`
    axios.get(url)
        .then(response=>{
            callback(response.data)
        })
        .catch(error=>console.log(error))
}

/*
// BACKUP
export function getSportEvents(ef, eg) {
    let url = `${base_url}GetEventsFromAPI/${ef}/${eg}`;
    const enableChacheProxy = store.state.settings.enable_cache_apiproxy;
    if(enableChacheProxy){
        url = ApiProxy.Get + encodeURI(url);
    }
    return new Promise((resolve, reject)=>{
      axios(url)
        .then(function (response) {
            let res = (enableChacheProxy)? response.data.Data : response.data
            const result = ParseEventArrayData(res);
            resolve(result);
        })
        .catch((error)=>reject(error))
    })
}
*/

// /*
export function getSportEvents(ef, eg) {
    const url =  `${geoff_api}GetCachedMatchDetails/${ef}/${eg}`;
    return new Promise((resolve, reject)=>{
      axios(url)
        .then(function (response) {
            let res = response.data.Data
            const result = ParseEventArrayData(res);
            resolve(result);
        })
        .catch((error)=>reject(error))
    })
}
// */

// GetMatchDetails 
// get info about particular match event: all markets and teams info (names, logos, date)
export function getSportSingleMatch(ef, eg) {
    getSportEvents(ef, eg)
    const url =  `${geoff_api}GetMatchDetails?eventFile=${ef}&eventGroup=${eg}`;
    return new Promise((resolve, reject)=>{
      axios(url)
        .then(function (response) {
            let res = response.data
            resolve(res)
        })
        .catch((error)=>reject(error))
    })
}

// NOT USED
 export function getEventDetails(sportCode, callback){
     axios.get(`${base_url}GetEventsDetail/${sportCode}?fullcard=1`)
         .then(response=>callback(response.data))
         .catch(error=>console.log(error))
 }

// NOT USED
export function getSportEventsList(sportCode, isFullCard = true){
    const URL = `${geoff_api}GetEventsDetailFullcard/${sportCode}?fullcard=${isFullCard ? 1 : 0}&v=1`
    return new Promise((resolve, reject)=>{
        axios.get(URL)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

export function getLastRacesResults(sportCode = null){
    let URL = `${geoff_api}GetRaceResultsFeed`
    if (sportCode) {
        URL = `${URL}?sportcode=${sportCode}`
    }
    return new Promise((resolve, reject)=>{
        axios.get(URL)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

export function getSportEventsListCountry(sportCode){
    // https://globalapi.geoffbanks.bet/api/geoff/GetCountryCompetitions/{sportcode - f} 
    const URL = `${geoff_api}GetCountryCompetitions/${sportCode}`
    return new Promise((resolve, reject)=>{
        axios.get(URL)
            .then(res=>{resolve(res.data)})
            .catch(error=>reject(error))
        })
}

export function getSportEventsTopList(sportCode){
    // https://globalapi.geoffbanks.bet/api/geoff/GetCountryCompetitions/{sportcode - f} 
    const URL = `${geoff_api}GetTopCompetitions/${sportCode}`
    return new Promise((resolve, reject)=>{
        axios.get(URL)
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}


// LOTTO
export function getLottoResults(){
    const url = `${betslip_prod_api}/api/lotto/get-49-results`;
    return new Promise((resolve, reject)=>{
        axios.get(url)
            .then(res=>{resolve(res.data)})
            .catch(error=>reject(error))
        })
}

export function getLottoEvents(){
    const url = `${betslip_prod_api}/api/lotto/get-49-events`;
    return new Promise((resolve, reject)=>{
        axios.get(url)
            .then(res=>{resolve(res?.data)})
            .catch(error=>reject(error))
        })
}

export function getLottoWagers(){
    const url = `${betslip_prod_api}/api/betslip/get-available-lotto-wagers`;
    return new Promise((resolve, reject)=>{
        axios.get(url)
            .then(res=>{resolve(res.data)})
            .catch(error=>reject(error))
        })
}

export function getLottoOddsInfo(){
    const url = `${betslip_prod_api}/api/lotto/info`;
    return new Promise((resolve, reject)=>{
        axios.get(url)
            .then(res=>{resolve(res.data)})
            .catch(error=>reject(error))
        })
}

export function submitLottoBet(model){
    const url = `${betslip_prod_api}/api/betslip/lotto-submitasync`;
    const headers = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
        }
    }
    return new Promise((resolve, reject)=>{
        axios.post(url, model, headers)
            .then(res=>{resolve(res.data)})
            .catch(error=>reject(error))
    })
}

/*
export function getAntepostMeetingDetail(ef, eg, e, callback) {

    //Need to use GetEventsFromAPI for all antepost (https://nextpage.nifty.pm/l/JxZ8XSkX1dGHJ)
    let url = `${base_url}GetEventsFromAPI/${ef}/${eg}`;
    if(store.state.settings.enable_cache_apiproxy){
        url = ApiProxy.Get + encodeURI(url);
    }
    axios.get(url)
        .then(function (response) {

            let res = (store.state.settings.enable_cache_apiproxy)? response.data.Data : response.data
            const result = ParseEventArrayData(res);
            callback(result);
        })
        .catch(error=>console.log(error))
}
*/
export function getStatements(userName, filterType, filterRange, callback) {
  axios.get(
      `${base_url}Getstatement_v2/${userName}/${filterType}/${filterRange}`,
      {headers: {"Content-Type": "application/x-www-form-urlencoded"}}
  ).then(res=>{
      callback(res.data)
  })
}

export function getStatementsNew(userName, filterType, filterRange, callback) {
    const url = `${betslip_prod_api}/api/user/get-user-transactions/${filterType}/${filterRange}`;
    axios.get(
        url,
        { 
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${betslipStore.state.authToken}`
            }
        }
    ).then(res=>{
        callback(res.data)
    })
  }

export function getAddressByZipcode(zipCode) {
  return new Promise((resolve, reject) => {
    axios.get("https://api.getaddress.io/find/" + zipCode + "?api-key=" + Reg_API_KEY)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function updateOddsFormatInPreferences(oddsFormat){
    return new Promise((resolve, reject)=>{
        getUserPreferences(store.state.user.customer_id).then(data=>{
            if (data.data.length) { // If preferences are exists, update this
                axios.patch(
                `${items_url}user_preferences/${data.data[0].id}`,
                {odds_format: oddsFormat},
                {headers: {Accept: "application/json", "Content-Type": "application/json"}}
                )
                .then(res=>resolve(res.data))
                .catch(error=>reject(error))
            } else { // Create new preferences
                axios.post(
                `${items_url}user_preferences`,
                { userid: store.state.user.customer_id, odds_format: oddsFormat,}
                )
                .then(res=>resolve(res.data))
                .catch(error=>reject(error))
            }
            store.dispatch('SET_USER_DATA', {oddsFormat: oddsFormat})
        })
            .catch(error=>reject(error))
    })
}

// Video Stream
export function getRMGEventListNew() {
    const URL = `${betslip_prod_api}/api/media/get-rmg-event-list`;
    return new Promise((resolve, reject)=>{
        axios.get(URL)
        .then(response=>resolve(response.data))
        .catch(error=>reject(error));
    })
}

export function getRMGStreamNew(data) {
    return new Promise((resolve, reject)=>{
        const URL = `${betslip_prod_api}/api/media/rmg-oauth-token`;
        axios.post(URL, data)
            .then(response=>resolve(response.data))
            .catch(error=>reject(error))
    })
}

export function getStreamEvents() {
    // let random_no = Math.random().toString(36).substring(7);
    // const URL = siteRoot + "/atr/events.php?c=" + random_no;
    // hardcode to prod (dev needs to be whitelisted at ART)
    const URL = "https://media.geoffbanks.bet/api/media/get-atr-events";
    return new Promise((resolve, reject)=>{
        axios.get(URL)
        .then(response=>resolve(response.data))
        .catch(error=>reject(error));
    })
}

export function getSISEvents(sportcode) {
    let URL = `${media_api}/api/media/get-sis-events`
    if (sportcode != "") {
        URL += `?sportcode=${sportcode}`;
    }
    return new Promise((resolve, reject)=>{
        axios.get(URL)
            .then(response=>resolve(response.data))
            .catch(error=>reject(error))
    })
}

export function getSISStream(data) {
    const URL = `${media_api}/api/media/get-sis-stream`
    return new Promise((resolve, reject)=>{
        axios.post(URL, data, { headers: { Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}` } })
            .then(response=>resolve(response.data))
            .catch(error=>reject(error))
      })
  }
  
export function getATRStream(eventId, userId, key) {
    return new Promise((resolve, reject)=>{
        // 'bwt1.attheraces.com' - test
        // 'bw197.attheraces.com' - prod
        const domain = 'bw197.attheraces.com'
        axios.get(`https://${domain}/ps/api/GetStreamingURLs?EventId=${eventId}&UserID=${userId}&PartnerCode=${partnerCode}&key=${key}&MediaFormat=Mobile`)
            .then(response=>resolve(response.data))
            .catch(error=>reject(error))
    })
}

export function getATRStreamUrl(eventId, userId, isTest = false, mediaFormat = 'Mobile') {
    return new Promise((resolve, reject)=>{
        const endpoint = `${betslip_prod_api}/api/Media/${isTest ? 'get-sport-stream-test-uri' : 'get-sport-stream-uri'}/${userId}/${eventId}?mediaformat=${mediaFormat}`
        axios.get(endpoint)
            .then(response=>resolve(response.data))
            .catch(error=>reject(error))
    })
}

// BetSlip

export function getWagerInfo(officeNo, referenceNo) {
    const URL = `${base_url_v0}cashier/wagerinfo-api.asp?officeNum=${officeNo}&type=credit&locale=&wagerNo=${referenceNo}&events=c:*EVENTS*&audit=`;
    return new Promise((resolve, reject)=>{
      axios.get(URL)
        .then(response=>resolve(response.data))
        .catch(error=>reject(error));
    })
}

// Paydoo

export function getCheckoutIdForPaydoo(data) {
  const URL = `${paydoo_base_url}${process.env.VUE_APP_MODE === 'production' ?'':'test/'}create_payment`
  return new Promise((resolve, reject)=>{
    axios.post(
        URL,
        data,
        {headers: {"Content-Type": "application/json; charset=utf-8", Authorization: `Bearer ${paydoo_token}`}}
    )
        .then(res=>resolve(res.data))
        .catch(error=>reject(error))
    })
}

export function getPaydooPaymentStatus(checkoutId, userName, provider) {
  let routerParam = 'checkout_status' // default (or provider === 'card') - when payment done by paynt card interface 
  // fast checkout (apple pay) - different url
  if (provider === 'applepay') {
    routerParam = 'checkout_status_mobile'
  }
  const URL = `${paydoo_base_url}${process.env.VUE_APP_MODE === 'production' ?'':'test/'}${routerParam}/${checkoutId}?user=${userName}`
  return new Promise((resolve, reject)=>{
    axios.get(
        URL,
        {headers: {"Content-Type": "application/json; charset=utf-8", Authorization: `Bearer ${paydoo_token}`}}
    )
        .then(res=>resolve(res.data))
        .catch(error=>reject(error))
    })
}

 // paynt (paydoo) - apple pay 
 export function getCheckoutIdForFastCheckout(data) {
    const URL = `${paydoo_base_url}${process.env.VUE_APP_MODE === 'production' ? '':'test/'}create_payment_mobile`
    return new Promise((resolve, reject)=>{
        axios.post(
            URL,
            data,
            {headers: {"Content-Type": "application/json; charset=utf-8", Authorization: `Bearer ${paydoo_token}`}}
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

// AXCESS

// users card list
export function geAxcessUserCards() {
    const URL = `${payment_api}/AxcessPayment/user-cards`
    return new Promise((resolve, reject)=>{
      axios.get(
            URL,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
      )
        //   .then(res=>resolve(res.data))
          .then(res=>{
            console.log('DEBUG', res, res?.data)
            resolve(res.data)
          })
          .catch(error=>reject(error))
      })
}

// delete saved card
export function axcessDeleteTokenization(id) {
    const URL = `${payment_api}/AxcessPayment/user-card?id=${id}`
    return new Promise((resolve, reject)=>{
      axios.delete(
            URL,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
      )
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
      })
}

export function getCheckoutAxcess(data) {
    const URL = `${payment_api}/AxcessPayment/create_payment`
    return new Promise((resolve, reject)=>{
        axios.post(
            URL,
            data,
            {   headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

export function getAxcessPaymentStatus(checkoutId, isRegisterCard = false) {
    let URL = `${payment_api}/AxcessPayment/checkout_status/${checkoutId}`
    if (isRegisterCard) {
        URL = `${URL}?registerCard=true`
    }
    return new Promise((resolve, reject)=>{
        axios.get(
            URL,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}
  
// PayPal
export function savePayPalDeposit(data){
    const URL = `${betslip_prod_api}/api/Paypal/OrderPostProcessing`
    return new Promise((resolve, reject)=>{
        axios.post(URL, data,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

// HEXOPAY

// users card list
export function getHexopayUserCards() {
    const URL = `${payment_api}/HexopayPayment/user-cards`
    return new Promise((resolve, reject)=>{
      axios.get(
            URL,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
      )
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
      })
}

// create checkout form
export function getHexopayCreateCheckout(data) {
    const URL = `${payment_api}/HexopayPayment/create-checkout`
    return new Promise((resolve, reject)=>{
      axios.post(
            URL,
            data,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
      )
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
      })
}

// create form for adding card to storage
export function hexopayCreateCheckoutTokenization(data) {
    const URL = `${payment_api}/HexopayPayment/create-checkout-tokenization`
    return new Promise((resolve, reject)=>{
      axios.post(
            URL,
            data,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
      )
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
      })
}

// delete saved card
export function hexopayDeleteTokenization(id) {
    const URL = `${payment_api}/HexopayPayment/user-card?id=${id}`
    return new Promise((resolve, reject)=>{
      axios.delete(
            URL,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
      )
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
      })
}

// create checkout for payment
export function hexopayCreateCheckoutPayment(data) {
    const URL = `${payment_api}/HexopayPayment/create-checkout-payment`
    return new Promise((resolve, reject)=>{
      axios.post(
            URL,
            data,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
      )
          .then(res=>resolve(res.data))
          .catch(error=>reject(error))
      })
}

// validate payment status or finish adding card to stored
export function getHexopayPaymentStatus(uid) {
    const URL = `${payment_api}/HexopayPayment/transaction-status?uid=${uid}`
    return new Promise((resolve, reject)=>{
        axios.get(
            URL,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

// Hexopay - Google pay
// {
//     "Amount": 11,
//     "Currency": "GBP",
//     "PaymentData": {}, // Googlepay response
//     "MobilePayServiceName": 0
// }
export function postHexopayGooglePay(data) {
    const URL = `${payment_api}/HexopayPayment/mobile-payment`
    return new Promise((resolve, reject)=>{
        axios.post(
            URL,
            data,
            { headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
            }}
        )
            .then(res=>resolve(res.data))
            .catch(error=>{

                // test - resolve fail
                // resolve ({
                //     "transaction": {
                //         "uid": "86838825-786ebd8b4c",
                //         "trackingId": "6980c738d541f569f7dbfbe2",
                //         "status": "failed",
                //         "message": "Payment was declined",
                //         "decimalAmount": 10,
                //         "currency": "GBP",
                //         "beProtectedVerification": {
                //             "status": "successful"
                //         },
                //         "payment": {
                //             "status": "failed",
                //             "message": "Payment was declined"
                //         }
                //     }
                // })

                // test - resolve success
                // resolve({
                //     "transaction": {
                //         "uid": "86838832-fc198be8fa",
                //         "trackingId": "6980c7add541f569f7dbfbe5",
                //         "status": "successful",
                //         "message": "Successfully processed",
                //         "decimalAmount": 10,
                //         "currency": "GBP",
                //         "beProtectedVerification": {
                //             "status": "successful"
                //         },
                //         "payment": {
                //             "status": "successful",
                //             "message": "Payment was approved"
                //         }
                //     }
                // })
                console.log('DEBUG', reject, error)
                // console.log('DEBUG', error)
                reject(error)
            })
        })
}


// Back Claim
export function checkClaim(username){
    const URL = `${items_url}20backclaim?filter[username]=${username}`
    return new Promise((resolve, reject)=>{
        axios.get(URL,{headers: {"Content-Type": "application/json; charset=utf-8"}}
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

export function postClaim(data){
    const URL = `${items_url}20backclaim`
    return new Promise((resolve, reject)=>{
        axios.post(URL, data,
            {headers: {"Content-Type": "application/json; charset=utf-8"}}
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

export function sendEmailByClaim(data){
    const URL = `${siteRoot}email/geoff.php?c=242`
    return new Promise((resolve, reject)=>{
        axios.post(URL, data,
            {headers: {"Content-Type": "multipart/form-data; charset=utf-8"}}
        )
            .then(res=>resolve(res))
            .catch(error=>reject(error))
        })
}

// horse racing images by race
// /api/Media/bulk-horsing-silk-logo/Ffos Las/2023-04-25/13:40
// TODO: remove, not used
export function getHorseRacingLogos(place, date, time){
    // place = 'Ffos Las'
    // time = '13:40' // `${hours}:${minutes}`
    // date = '2023-04-25' // `${year}-${month}-${date}`
    const URL = `${betslip_prod_api}/api/media/bulk-horsing-silk-logo/${place}/${date}/${time}`
    return new Promise((resolve, reject)=>{
        axios.get(URL,{headers: {"Content-Type": "application/json; charset=utf-8"}})
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

// horse racing images by race
export function getHorseRacingSilkLogos(model){
    const URL = `${betslip_prod_api}/api/media/bulk-horsing-silk-logo/`
    return new Promise((resolve, reject)=>{
        axios.post(URL, model, {headers: {"Content-Type": "application/json; charset=utf-8"}})
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

// horse racing images and additiona info by race (from Timeform)
export function getHorseRacingAdditionalInfo(model){
    // https://geoffbanks-api.azurewebsites.net/api/geoff/bulk-horsing-info
    const URL = `${betslip_prod_api}/api/geoff/bulk-horsing-info`
    return new Promise((resolve, reject)=>{
        axios.post(URL, model, {headers: {"Content-Type": "application/json; charset=utf-8"}})
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

// teams images
export function getMedia(teamName){
    const URL = `${betslip_prod_api}/api/media/football-logo?name=${teamName}`
    return new Promise((resolve, reject)=>{
        axios.get(URL,{headers: {"Content-Type": "application/json; charset=utf-8"}})
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}
// fotball teams images bulk
// not used: getSportLogoBulk instead.
// export function getMediaBulk(teamNames){
//     const URL = `${betslip_prod_api}/api/media/bulk-football-logo`
//     return new Promise((resolve, reject)=>{
//         axios.post(URL,teamNames,{headers: {"Content-Type": "application/json; charset=utf-8"}})
//             .then(res=>resolve(res.data))
//             .catch(error=>reject(error))
//         })
// }

// get bulk logos for different sports
// model: 
// [
//     {
//         "teamName": "Estonia",
//         "sportcode": "f"
//     }
// ]
export function getSportLogoBulk(model){
    const URL = `${betslip_prod_api}/api/media/bulk-sport-logo`
    return new Promise((resolve, reject)=>{
        axios.post(URL, model, {headers: {"Content-Type": "application/json; charset=utf-8"}})
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
        })
}

// update deposit limit
export function updateDepositLimit(data) {
    return new Promise((resolve, reject)=>{
      
        const headers = {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
        };

        axios.post(
            `${betslip_prod_api}/api/Forms/update-deposit-limits-v1`,
            data,
            { headers }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

// Request Withdrawal
// data:
// {
//     "Firstname":"Dmitry",			not null, not empty
//     "Lastname":"Shish",				not null, not empty
//     "Username":"Testuser",			not null, not empty
//     "Pounds":70,				        Range(1-maxValue)
//     "Pence":0,					    Range(0-maxValue)
//     "isUseMyPreviousDetails":bool    -
//     "LastFourBankAccount":"12345678",not null, not empty, MinLength(4), MaxLength(4)
//     "BankAccountNumber":"12345678",	not null, not empty, MinLength(8), MaxLength(8)
//     "SortCode":"123456",			    not null, not empty, MinLength(6), MaxLength(6)
//     "IBANNumber": "ABC123-6"			-
// }
export function requestWithdrawal(data) {
    return new Promise((resolve, reject)=>{
        const headers = {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
        };

        axios.post(
            `${betslip_prod_api}/api/Forms/request-withdrawal-v1`,
            data,
            { headers }
        )
            .then(res=>resolve(res.data))
            .catch(error=>reject(error))
    })
}

export function getSportByTitle(sportTitle) {
    return SPORTS.find(el => el.title === sportTitle)
}


export const OTHER_LINKS = [
    {
        label: 'Terms And Conditions',
        link: '/info/Terms And Conditions',
        isExternal: false
    },
    {
        label: 'Privacy Policy',
        link: '/info/Privacy Policy',
        isExternal: false
    },
    {
        label: 'Cookie Policy',
        link: '/info/Cookie Policy',
        isExternal: false
    },
    {
        label: 'Affiliates',
        link: '/info/Affiliates',
        isExternal: false
    },
    {
        label: 'About Us',
        link: '/info/About Us',
        isExternal: false
    },
    {
        label: 'Contact Details',
        link: '/info/Contact Details',
        isExternal: false
    },
    {
        label: 'Responsible Gambling',
        link: '/info/ResponsibleGambling',
        isExternal: false
    },
    {
        label: 'Help',
        link: '/info/Help',
        isExternal: false
    },
    {
        label: 'Betting Rules',
        link: '/info/Betting Rules',
        isExternal: false
    },
    {
        label: 'Best Odds Guaranteed',
        link: '/info/Best Odds Guaranteed',
        isExternal: false
    },
    {
        label: 'Job at Geoff Banks',
        link: 'https://www.indeed.co.uk/viewjob?t=trading+assistant&jk=917cbd12c2234b2f&_ga=2.154254520.1857144260.1541691432-1777259780.1541691432',
        isExternal: true
    },
    {
        label: 'Gambling Matters',
        link: 'https://gamblingmatters.wordpress.com/',
        isExternal: true
    },
] 


/// home links 
export const TOP_MENU_LINKS = [
    // {
    //     name: 'football',
    //     link: '/#/sport/Football'
    // },
    // {
    //     name: 'horse racing',
    //     link: '/#/sport/Horse%20Racing'
    // },
    // {
    //     name: 'greyhounds',
    //     link: '/#/sport/Greyhounds'
    // },
    // {
    //     name: 'cricket',
    //     link: '/#/sport/Cricket'
    // },
    // {
    //     name: 'golf',
    //     link: '/#/sport/golf'
    // },
    // {
    //     name: 'account',
    //     link: '/#/transactions'
    // },
    // {
    //     name: 'safer gambling',
    //     link: '/#/info/ResponsibleGambling'
    // }
]

export const registerCountries = [
    { name: "United Kingdom", defaultCurrency: 826 },
    { name: "Ireland", defaultCurrency: 978},
]

export const mediaCorners = [
    // {
    //     name: 'blog',
    //     imageName: 'geoff_blog_transparent.png',
    //     linkUrl: 'https://geoffbanksracing.com/'
    // },
    {
        name: 'gamblingmatters',
        imageName: 'image-20250410-102702.png',
        linkUrl: 'https://gamblingmatters.wordpress.com/'
    },
    // {
    //     name: 'furlong',
    //     imageName: 'the_final_furlong_logo_black_yellow.jpg',
    //     linkUrl: 'https://www.youtube.com/@finalfurlongpodcast'
    // }
]

export const socialMedia = [
    {
        name: 'Instagram',
        linkUrl: 'https://www.instagram.com/geoffbanksbet/',
        icon: 'social-inst'
    },
    {
        name: 'X',
        linkUrl: 'https://x.com/betgeoffbanks',
        icon: 'social-x'
    },
    {
        name: 'Facebook',
        linkUrl: 'https://www.facebook.com/GeoffBanksOnline/',
        icon: 'social-fb'
    }
]

// file validation
export const fileValidation = {
    singleMb: 10, // single file size allowed
    formMb: 25, // whole form max size allowed
    formats: ['png', 'jpg', 'jpeg', 'pdf'], // array for check
    accept: ".png, .jpg, .jpeg, .pdf", // file input
    errorMessageByName: (fileName) => {return `${fileName} file must be a png, jpg, jpeg or pdf file.`}
}

//eslint-disable-next-line
export const emailRegEx =  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

